// import "friendly-challenge/widget";

﻿// CDN Module für das clientseitige Code Highlighting 
declare module 'https://esm.sh/shiki@1.29.2' {
    export function codeToHtml(code: string, options: { lang: string; theme: string }): Promise<string>;
}
declare module 'https://esm.sh/highlight.js@11.11.1/lib/common' {
    const hljs: { highlightAuto(code: string): { language: string } };
    export default hljs;
}

/*! MyScript */
class My {
    public headerPositionTop = document.querySelector('#fixedHeader') ? document.querySelector<HTMLElement>('#fixedHeader')?.offsetTop : null;
    public indexPositionTop = document.querySelector('.index') ? document.querySelector<HTMLElement>('.index')?.offsetTop : null;
    public logoState = "b";
    public logoSize = 0;
    public logo2Margin = 0;
    public waitCicle = true;
    public priceBase: number[] = [];

    // Timer Interval Id für Kundenbewertungen
    private _timerIdCustomerReview: number;

    constructor() {
        this.handleIntersectionObserver();

        this.handleNavigation();

        this.handleSuccessPageTracking();

        this.handleComparisonSlider();

        this.handleReactTogglePrice();

        this.handleHeightLikeWidth();

        this.handleCustomNumberStepper();

        this.matchContainerHeight();

        this.matchContainerMinHeight();

        // Accordion Video Handling hinzufügen
        this.handleAccordionVideo();

        // Animation Container hinzufügen
        this.handleAnimationContainer();

        // Scroll-Video-Mask Animation (Video wächst von unten auf volle Breite)
        this.handleScrollVideoMask();

        // Wechsel der Tabs im Split Layout
        this.handleSplitMediaTabs();

        // Wechsel der Tabs in der Anforderungstabelle
        this.handleSpecificationsTable();

        // Wechsel zwischen den Produktbereichen auf der Kaufen Seite
        this.handleProductSwitch();

        // Aufklappbereich der Kachel Axogram Kostenlos
        this.handleAxogramFreeDialog();

        // Wechsel der Laufzeit auf der Kaufen Seite
        this.handleTermSwitch();

        // Schwebender Laufzeitumschalter in der schmalen Ansicht
        this.handleStickyTermSwitch();

        // Einblendung von Umschaltern und Kacheln wie auf lumion.com
        this.handleCardReveal();

        // Gleitende Markierung in beiden Umschaltern
        this.handleSwitchIndicators();

        // Aktionsbanner
        this.initPopUp();

        // Ein Header der sich an den oberen Bildschirmrand anheftet
        window.addEventListener("scroll", () => {
            this.updateHeader();
        });
        window.addEventListener("resize", () => {
            this.updateHeader();
            this.prepareSliders(true);
            this.matchContainerHeight();
            this.matchContainerMinHeight();
        });

        this.updateHeader();
        this.prepareSliders();

        this.handleClickEvents();

        this.handleFormErrors();

        // Select Style anpassen
        var selectAll = document.querySelectorAll<HTMLSelectElement>('select');
        for (let i = 0; i < selectAll.length; i++) {
            const element = selectAll[i];
            this.updateSelectStyle(element);

            element.addEventListener('change', (e) => {
                this.updateSelectStyle(<HTMLSelectElement>e.target);

                if (element.classList.contains('reload-on-change')) {
                    this.submitReloadForm(element);
                }
            });
        }

        var elementsReloadOnChange = document.getElementsByClassName('reload-on-change');
        for (let i = 0; i < elementsReloadOnChange.length; i++) {
            const element = <HTMLElement>elementsReloadOnChange[i];

            // Selects sind bereits oben angebunden.
            if (element.tagName === 'SELECT') {
                continue;
            }

            element.addEventListener('change', () => {
                this.submitReloadForm(element);
            })
        }

        // Cookie reCaptcha - EventListener und Handling
        // this.handleRecaptcha();

        // Kundenbewertung (eigene Seite)
        this.handleNewCustomerReview();

        // Kundenbewertungen Startseite
        this.handleCustomerReviewStart();

        // Hebt die geklickte Rezension auf der Übersicht hervor
        this.highlightSelectedCustomerReview();

        this.handleCountdown();

        // Grund Block warum keine Verlängerung gewünscht ist anzeigen
        this.handleReasonNoSubExtensionBlock();
        
        // Blog Suche
        this.handleBlogSearch();

        // Background durchwechseln
        //E.H. - 23.10.19: Vorerst auskommentiert
        //if (document.querySelectorAll(('.background.big.changeing').length > 0) {
        //    // Anzahl der zu wechselnden Bilder
        //    let countImg = 8;

        //    setInterval(() => {
        //        document.querySelectorAll(('.background.big.changeing .inner').forEach((i, e) => e.classList.toggle("unloaded"));
        //        let raw = document.querySelector('.background.big.changeing .inner.unloaded').style.backgroundImage;

        //        //Je nach Browser anderes Symbol
        //        let sign = raw.slice(-2, -1);
        //        sign = sign === '\'' || sign === '\"' ? sign : '';

        //        // Aus altem Wert neuen Berechnen
        //        let val = parseInt(raw.slice(-6 - sign.length, -5 - sign.length));
        //        val = val < (countImg - 1) ? (val += 2) : (val += 2 - countImg);

        //        setTimeout(() => {
        //            document.querySelector('.background.big.changeing .inner.unloaded').style.backgroundImage = raw.slice(0, -6 - sign.length) + val.toString() + '.jpg' + sign + ')';
        //        }, 2000);
        //    }, 5000);
        //}

        // Kategorie wechseln
        window.addEventListener('hashchange', (e) => {
            this.updateCategories();
        });
        this.updateCategories();

        //Upload Button laden
        const uploadAll = document.querySelectorAll('.upload');
        if (uploadAll && uploadAll.length) {
            // const uploadButton = document.querySelector('#uploadButton');
            // if (uploadButton) {
            //     uploadButton.addEventListener("click", () => {
            //         document.querySelector<HTMLInputElement>("input[type='file']")?.click();
            //     });
            // }

            const inputTypeFile = document.querySelector("input[type='file']");
            if (inputTypeFile) {
                inputTypeFile.addEventListener("change", (e: Event) => {
                    let target = <HTMLInputElement>e.target;
                    const uploadText = document.querySelector<HTMLElement>('#uploadText');
                    if (uploadText) {
                        uploadText.innerText = target.value.replace(/C:\\fakepath\\/i, '');
                    }
                });
            }
        }

        /**
         * Prüft, ob ein Hash im Link vorhanden ist und scrollt die Höhe des Headers wieder zurück
         */
        if (document.location.hash) {
            const hashId = document.location.hash.substring(1, document.location.hash.length);
            const a = document.getElementById(hashId);
            if (!a) {
                return;
            }
            const headerList = document.getElementsByTagName('header');
            setTimeout(function () {
                const bc = <HTMLElement>a;
                const navHeight = (<HTMLElement>headerList[0]).offsetHeight;
                const pxToTop = (bc.offsetTop - navHeight);

                window.scrollTo(0, pxToTop);
            }, 10);
        }


        //Nach unten scrollen
        const downAll = document.querySelectorAll(('.down'));
        for (let i = 0; i < downAll.length; i++) {
            const element = downAll[i];

            element.addEventListener("click", (e) => {
                const bcList = document.getElementsByClassName('content-down');
                if (!bcList) {
                    return;
                }

                const headerList = document.getElementsByTagName('header');
                if (headerList) {
                    const bc = <HTMLElement>bcList[0];
                    const navHeight = (<HTMLElement>headerList[0]).offsetHeight;
                    const pxToTop = (bc.offsetTop - navHeight);

                    window.scrollTo(0, pxToTop);
                }
            });
        }


        // Tabelle für mobile (nicht im Backend!)
        const bodyClassList = document.getElementsByTagName('body')[0];
        if (bodyClassList === undefined) {
            return;
        }
        if (!bodyClassList.classList.contains('backend')) {
            const trAll = document.querySelectorAll(('tr'));
            for (let i = 0; i < trAll.length; i++) {
                const element = <HTMLTableRowElement>trAll[i];
                if (element.children.length >= 3) {
                    let children = element.querySelectorAll('th,td');

                    let newLine = document.createElement('tr');
                    let clone = children[0].cloneNode(true);
                    newLine.appendChild(clone);
                    newLine.children[0].setAttribute("colspan", element.children.length.toString());
                    newLine.classList.add("mobile");

                    children[0].classList.add("desktop");
                    if (element.parentElement) {
                        element.parentElement.insertBefore(newLine, element);
                    }
                }
            }
        }


        // Regionen anpassen
        this.updateRegions();
        const countryAll = document.querySelectorAll<HTMLInputElement>("[id$='Land'], [id$='Country'], [id$='CountryCode']");
        for (let i = 0; i < countryAll.length; i++) {
            const element = countryAll[i];

            element.addEventListener("change", (e) => {
                this.updateRegions();
            });
        }

        var elCounter = 0;
        const priceBaseAll = document.querySelectorAll('.priceBase');
        for (let i = 0; i < priceBaseAll.length; i++) {
            const element = <HTMLElement>priceBaseAll[i];
            element.id = (elCounter++).toString();
            this.priceBase.push(parseFloat(element.innerText.replace('.', '').replace(' ', '').replace(',', '.')));
        }

        //Zahlungsarten Auswahl
        if (document.querySelector('#orderForm')) {
            const billingDataBillingTypeAll = document.querySelectorAll('[name="BillingData.BillingType"]');
            for (let i = 0; i < billingDataBillingTypeAll.length; i++) {
                const element = billingDataBillingTypeAll[i];

                element.addEventListener("change", (e) => {
                    this.updateBillingType(e);
                });
            }
        }

        if (document.querySelector('.jsOnly')) {
            const jsOnlyAll = document.querySelectorAll('.jsOnly');

            for (let i = 0; i < jsOnlyAll.length; i++) {
                const element = <HTMLElement>jsOnlyAll[i];
                element.style.display = 'block'
            }
        }

        this.initDiscount();

        this.handleDSGVOdelete();

        this.handleAutocomplete();

        // Syntax Highlighting für Code Blöcke auf der Blogdetailseite
        this.initBlogCodeHighlighting();
    }

    /**
     * Syntax Highlighting für Code Blöcke auf der Blogdetailseite.
     * Die Bibliotheken werden nur geladen, wenn der Beitrag tatsächlich Code enthält
    */
    private async initBlogCodeHighlighting(): Promise<void> {
        // Snapshot der Code Blöcke, da wir die Elemente gleich ersetzen
        const blocks = Array.from(document.querySelectorAll('.blog-content pre.blog-code'));

        // Kein Code im Beitrag → gar nichts nachladen
        if (!blocks.length) {
            return;
        }

        // Bibliotheken erst bei Bedarf laden 
        const [{ codeToHtml }, { default: hljs }] = await Promise.all([
            import('https://esm.sh/shiki@1.29.2'),
            import('https://esm.sh/highlight.js@11.11.1/lib/common')
        ]);

        // highlight.js Sprach IDs auf Shiki IDs mappen 
        const langMap: Record<string, string> = {
            xml: 'html',
            plaintext: 'text',
            objectivec: 'objective-c',
            'php-template': 'php',
            'python-repl': 'python',
            vbnet: 'vb'
        };

        for (const pre of blocks) {
            const codeEl = pre.querySelector('code');
            if (!codeEl) {
                continue;
            }

            const source = codeEl.textContent ?? '';

            // Sprache automatisch erkennen
            const detected = hljs.highlightAuto(source).language;
            const lang = langMap[detected] || detected || 'text';

            let html: string;
            try {
                html = await codeToHtml(source, { lang, theme: 'dark-plus' });
            } catch {
                html = await codeToHtml(source, { lang: 'text', theme: 'dark-plus' });
            }

            pre.outerHTML = html;
        }
    }

    /**
     * Sendet bei Reload-Feldern das zugehörige Formular ab
     * @param element - Das geänderte Element, das den Reload auslöst (z.B. Select, Input)
     * @returns void
     */
    private submitReloadForm(element: Element): void {
        const formElement = element as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement;
        const parentForm = element.closest('form') as HTMLFormElement | null;
        const form = formElement.form ?? parentForm;

        if (!form) {
            return;
        }

        form.action = form.id ? `${location.pathname}#${form.id}` : location.pathname;
        form.submit();
    }

    /**
     * client-seitige Blog-Suche.
    */
    private handleBlogSearch() {
        const input = document.getElementById('blog-search-input') as HTMLInputElement | null;

        // Kein Suchfeld im DOM → nicht auf Blog-Seite, früh abbrechen
        if (!input){
            return;
        }

        // Alle Blogs einmalig cachen — ändern sich nach dem Seitenaufruf nicht mehr
        const posts         = Array.from(document.querySelectorAll<HTMLElement>('.blog-container > a'));
        const banner        = document.getElementById('blog-search-banner');
        const infoText      = document.getElementById('blog-search-info-text');
        const resetLink     = document.getElementById('blog-search-reset');
        const noResults     = document.getElementById('blog-no-results');
        const noResultsText = document.getElementById('blog-no-results-text');

        // Kategorie Filter Buttons cachen aktive ids im Set führen
        const categoryButtons  = Array.from(document.querySelectorAll<HTMLButtonElement>('.blog-category-btn'));
        const selectedCategories = new Set<string>();

        // Debounce-Timer: wird bei jedem Tastendruck zurückgesetzt
        let timer: ReturnType<typeof setTimeout>;

        /**
         * XSS-Schutz: Konvertiert Nutzereingabe in sicheren HTML-String.
         * Sonderzeichen wie <, >, " werden escaped — nie direkt als innerHTML nutzen.
        */
        const escapeHtml = (text: string): string => {
            const div = document.createElement('div');
            div.appendChild(document.createTextNode(text));
            return div.innerHTML;
        };

        /**
         * Kernfunktion: Filtert alle Posts anhand des Suchbegriffs.
         *
         * @param rawTerm - Originaleingabe des Nutzers (für Anzeige im Banner)
         *                  Leerer String = kein Filter, alle Posts sichtbar
         */
        const applyFilter = (rawTerm: string): void => {
            // Lowercase nur für den Vergleich — Originalschreibweise für Anzeige behalten
            const term = rawTerm.toLowerCase();
            let visibleCount = 0;

            // Jeden Post gegen Suchbegriff und Kategoriefilter prüfen
            posts.forEach(post => {
                const searchHit =
                    !term ||                                          // kein Suchbegriff → immer treffer
                    post.dataset.searchTitle?.includes(term)  ||     // Titel
                    post.dataset.searchDesc?.includes(term)   ||     // Kurzbeschreibung
                    post.dataset.searchAuthor?.includes(term) ||     // Autor
                    post.dataset.searchDate?.includes(term);         // Datum (dd.MM.yyyy)
                
                const postCategories = post.dataset.searchCategories
                    ? post.dataset.searchCategories.split(',')
                    : [];
                const categoryHit =
                    selectedCategories.size === 0 ||
                    postCategories.some(id => selectedCategories.has(id));

                const hit = searchHit && categoryHit;

                post.style.display = hit ? '' : 'none';
                if (hit) {
                    visibleCount++;
                }
            });

            // Ein Filter ist aktiv, wenn ein Suchbegriff vorliegt oder Kategorien gewählt sind
            const filterActive = !!rawTerm || selectedCategories.size > 0;

            // Banner ein-/ausblenden und Suchbegriff anzeigen
            if (banner) {
                banner.style.display = rawTerm ? '' : 'none';
            }

            if (infoText) {
                infoText.innerHTML = rawTerm
                    ? `Posts für die Suchanfrage <span>"${escapeHtml(rawTerm)}"</span> werden angezeigt.`
                    : '';
            }
            
            if (resetLink) {
                resetLink.style.display = rawTerm ? '' : 'none';
            }

            // No Results einblenden, wenn ein Filter (Suche oder Kategorie) aktiv ist und kein Treffer
            if (noResults) {
                noResults.style.display = (filterActive && visibleCount === 0) ? '' : 'none';
            }

            if (noResultsText && filterActive && visibleCount === 0) {
                noResultsText.innerHTML = rawTerm
                    ? `Keine Artikel für „<em>${escapeHtml(rawTerm)}</em>" gefunden.`
                    : 'Keine Artikel in den gewählten Kategorien gefunden.';
            }

            // URL synchronisieren ohne Seitenreload — ermöglicht Teilen des Suchergebnisses
            const url = new URL(window.location.href);
            rawTerm ? url.searchParams.set('q', rawTerm) : url.searchParams.delete('q');
            history.replaceState(null, '', url.toString());
        };

        // Shareable URL: ?q= beim Seitenaufruf sofort anwenden (z.B. geteilter Link)
        const initialTerm = new URLSearchParams(window.location.search).get('q')?.trim() ?? '';
        if (initialTerm) {
            input.value = initialTerm;
            applyFilter(initialTerm);
        }

        // Live-Filter mit 250ms Debounce — verhindert Filter-Aufruf bei jedem Tastendruck
        input.addEventListener('input', () => {
            clearTimeout(timer);
            timer = setTimeout(() => applyFilter(input.value.trim()), 250);
        });

        // Filter Buttons Auswahl toggeln und Filter neu anwenden
        categoryButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const id = btn.dataset.categoryId;
                if (!id) {
                    return;
                }

                if (selectedCategories.has(id)) {
                    selectedCategories.delete(id);
                    btn.classList.remove('active');
                } else {
                    selectedCategories.add(id);
                    btn.classList.add('active');
                }

                applyFilter(input.value.trim());
            });
        });
    }

    /** Trackt Erfolgsseiten Events */
    private handleSuccessPageTracking(): void {
        const path = window.location.pathname.toLowerCase();
        const hash = window.location.hash;
        
        if (path.indexOf('/erfolg') !== -1) {
            // Demo Download Anfrage
            if (hash === '#orderDemo') {
                this.trackEventWhenReady('lumion_demo_download', {
                    'send_to': ['AW-1068765674/llM6CNL_sLgDEOqj0P0D', 'G-R3BXZ4607T'],
                    'event_category': 'Demo',
                    'event_label': 'Demo Download angefordert',
                    'value': 1
                }, 'lumion_demo_download_tracked');
            }
        }
    }

    /**
     * Trackt ein Event sobald GA4 verfügbar ist
     * @param eventName - Name des Events
     * @param eventParams - Event Parameter
     * @param sessionKey - Optional: SessionStorage Key um doppeltes Tracking zu verhindern
    */
    private trackEventWhenReady(
        eventName: string, 
        eventParams: Record<string, unknown> = {}, 
        sessionKey?: string
    ): void {
        // Prüfen ob bereits getrackt (falls sessionKey angegeben)
        if (sessionKey && sessionStorage.getItem(sessionKey)) {
            return;
        }
        
        const maxAttempts = 50; // 5 Sekunden bei 100ms Intervall
        let attempts = 0;
        
        const checkGA4 = setInterval(() => {
            attempts++;
            
            if (typeof window['gtag'] !== 'undefined' && window['dataLayer']) {
                clearInterval(checkGA4);
                
                window['gtag']('event', eventName, eventParams);
                
                if (sessionKey) {
                    sessionStorage.setItem(sessionKey, 'true');
                }
            } else if (attempts >= maxAttempts) {
                clearInterval(checkGA4);
            }
        }, 100);
    }

    /**
     * Trackt ein Custom Event (für externe Aufrufe)
     * z.B. für Button Klicks
     * Beispiel
     * <button onclick="my.trackEvent('cta_click', {button_name: 'Jetzt kaufen'})">Kaufen</button>
     * @param eventName - Name des Events  
     * @param eventParams - Event Parameter
     */
    public trackEvent(eventName: string, eventParams: Record<string, unknown> = {}): void {
        if (typeof window['gtag'] !== 'undefined') {
            window['gtag']('event', eventName, eventParams);
        }
    }

    /**
     * Handhabt das Wechseln von Videos basierend auf Accordion-Auswahl
     * Diese Funktion ermöglicht es, dass beim Klicken auf Accordion Elemente
     * automatisch das passende Video oder Bild angezeigt wird
     * Unterstützt mehrere Accordion-Sektionen auf einer Seite
    */
    private handleAccordionVideo(): void {
        // Findet alle Accordion-Sektionen (media-with-text Container)
        const accordionSections = document.querySelectorAll('.media-with-text');
        
        if (accordionSections.length === 0) {
            return;
        }

        // Verarbeitet jede Sektion unabhängig
        accordionSections.forEach(section => {
            const video = section.querySelector('video#accordionVideo') as HTMLVideoElement;
            const image = section.querySelector('img#accordionImage') as HTMLImageElement;
            const accordionInputs = section.querySelectorAll('.expander-area input[type="checkbox"]');

            if (!video || !image || accordionInputs.length === 0) {
                return;
            }

            // Speichert den initialen Zustand (welches Element ist sichtbar)
            const isVideoInitiallyVisible = window.getComputedStyle(video).display !== 'none';
            const isImageInitiallyVisible = window.getComputedStyle(image).display !== 'none';
            
            // Speichert das Video/Bild das am Anfang angezeigt wird 
            const defaultVideoSrc = video.querySelector("source")?.getAttribute("src") || "";
            const defaultVideoAria = video.getAttribute("aria-label") || "";
            const defaultImageSrc = image.src || "";
            const defaultImageAlt = image.alt || "";
            
            // EventListener für jede Checkbox in dieser Sektion
            accordionInputs.forEach(input => {
                input.addEventListener("change", (event) => {
                    // Holt die angeklickte Checkbox 
                    const target = event.target as HTMLInputElement;
                    
                    // Wenn eine Checkbox aktiv ist (also angeklickt wurde), alle anderen in dieser Sektion schließen
                    if (target.checked) {
                        accordionInputs.forEach(otherInput => {
                            if (otherInput !== target) {
                                (otherInput as HTMLInputElement).checked = false;
                            }
                        });

                        // Prüft ob die Checkbox ein Video oder Bild anzeigen soll
                        if (target.dataset.videoSrc) {
                            // Fall 1: Video anzeigen
                            video.style.display = 'block';
                            image.style.display = 'none';
                            video.src = target.dataset.videoSrc;
                            video.setAttribute("aria-label", target.dataset.videoAria || "");
                            video.load();
                            video.play();
                        } else if (target.dataset.imageSrc) {
                            // Fall 2: Bild anzeigen
                            video.style.display = 'none';
                            image.style.display = 'block';
                            image.src = target.dataset.imageSrc;
                            image.alt = target.dataset.imageAlt || "";
                        }
                    } else {
                        // Fall 3: Checkbox wurde abgewählt => Initialen Zustand wiederherstellen
                        if (isVideoInitiallyVisible) {
                            // Initial war Video sichtbar
                            video.style.display = 'block';
                            image.style.display = 'none';
                            video.src = defaultVideoSrc;
                            video.setAttribute("aria-label", defaultVideoAria);
                            video.load();
                            video.play();
                        } else if (isImageInitiallyVisible) {
                            // Initial war Bild sichtbar
                            video.style.display = 'none';
                            image.style.display = 'block';
                            image.src = defaultImageSrc;
                            image.alt = defaultImageAlt;
                        }
                    }
                });
            });
        });
    }

    /**
     * Handhabt die Animation für den Background Container
     * Hintergrund kommt von unten hoch und skaliert sich dabei
    */
    private handleAnimationContainer(): void {
        const container = document.querySelector('.animation-container') as HTMLElement;
        const background = document.getElementById('background');
        const textWhite = document.getElementById('text-white') as HTMLElement;
        const stickyWrapper = document.querySelector('.sticky-wrapper') as HTMLElement;
        const video = background?.querySelector('video');

        // Abbruch, wenn benötigte Elemente nicht vorhanden sind
        if (!container || !background || !textWhite || !stickyWrapper) {
            return;
        }
        
        /**
         * Easing-Funktion für sanfte Beschleunigung/Verzögerung
         * Verläuft schneller am Anfang und Ende, langsamer in der Mitte
         * @param t - Fortschritt zwischen 0 und 1
         * @returns Geglätteter Fortschrittswert
         */
        const easeInOutQuart = (t: number): number => {
            return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
        };

        // Fortschritts-Variablen für sanfte Animation
        let currentProgress = 0;  // Aktueller Animationsfortschritt 
        let targetProgress = 0;   // Ziel-Fortschritt basierend auf Scroll-Position
        let isAnimating = false;  // Verhindert mehrfache Animation-Frames

        /**
         * Linear Interpolation - Glättet Übergänge zwischen Werten
         * @param start - Startwert
         * @param end - Zielwert
         * @param factor - Interpolationsfaktor (0-1)
         * @returns Interpolierter Wert
         */
        const lerp = (start: number, end: number, factor: number): number => {
            return start + (end - start) * factor;
        };

        /**
         * Hauptfunktion für die Animation
         * Wird bei Scroll/Resize aufgerufen und aktualisiert alle Animationswerte
        */
        const updateAnimation = () => {
            // Container-Position relativ zum Viewport ermitteln
            const containerRect = container.getBoundingClientRect();
            const containerTop = containerRect.top;
            const windowHeight = window.innerHeight;
            
            // Ziel-Fortschritt zurücksetzen
            targetProgress = 0;
            
            // Fortschritt berechnen, wenn Container oberhalb des Viewports ist
            if (containerTop <= 0) {
                // Wie weit ist der Container bereits durchgescrollt?
                // Verhältnis: gescrollte Distanz / scrollbare Höhe
                targetProgress = Math.abs(containerTop) / (containerRect.height - windowHeight);
                // Auf max. 100% begrenzen
                targetProgress = Math.min(targetProgress, 1);
            }

            // Sanfte Annäherung an Ziel-Fortschritt (Smooth Scrolling-Effekt)
            currentProgress = lerp(currentProgress, targetProgress, 0.1);
            // Easing-Funktion anwenden für natürlichere Bewegung
            const easedProgress = easeInOutQuart(currentProgress);

            // Startet bei translateY(100%) (außerhalb) und endet bei 0%
            const translateY = 100 - (100 * easedProgress);
            
            // Minimale Breite: 30% der Fensterbreite
            const minWidth = window.innerWidth * 0.3;
            // Maximale Breite: volle Wrapper-Breite
            const maxWidth = stickyWrapper.offsetWidth;
            // Minimale Höhe: 16:9 Seitenverhältnis der minimalen Breite
            const minHeight = minWidth * 0.5625;
            // Maximale Höhe: volle Wrapper-Höhe
            const maxHeight = stickyWrapper.offsetHeight;
            
            // Aktuelle Größe basierend auf Fortschritt interpolieren
            const currentWidth = minWidth + (maxWidth - minWidth) * easedProgress;
            const currentHeight = minHeight + (maxHeight - minHeight) * easedProgress;
            
            // Styles auf Background-Element anwenden
            background.style.transform = 'translateY(' + translateY + '%)';
            background.style.width = currentWidth + 'px';
            background.style.height = currentHeight + 'px';

            // Startet mit 20px Rundung, wird zu 0px bei vollständiger Animation
            const borderRadius = 20 - (20 * easedProgress);
            background.style.borderRadius = borderRadius + 'px';

            // Video Zoom Effekt
            // Video wird von 125% auf 100% Größe skaliert
            if (video) {
                const scale = 1.25 - (0.25 * easedProgress);
                video.style.transform = 'scale(' + scale + ')';
            }
            
            // Bounding Rectangles für Überlappungsberechnung
            const bg = background.getBoundingClientRect();
            const txt = textWhite.getBoundingClientRect();
            
            // Schnittmenge der beiden Rechtecke berechnen
            const overlapLeft = Math.max(txt.left, bg.left);
            const overlapRight = Math.min(txt.right, bg.right);
            const overlapTop = Math.max(txt.top, bg.top);
            const overlapBottom = Math.min(txt.bottom, bg.bottom);
            
            // Prüfen ob eine Überlappung existiert
            if (overlapRight <= overlapLeft || overlapBottom <= overlapTop) {
                // Keine Überlappung => Text komplett verstecken
                textWhite.style.clipPath = 'inset(100% 0 0 0)';
            } else {
                // Überlappung vorhanden => ClipPath auf Schnittbereich setzen
                
                // Inset-Werte prozentual zur Text-Box berechnen
                // Top: Abstand vom oberen Rand der Text-Box zur Überlappung
                const insetTop = ((overlapTop - txt.top) / txt.height) * 100;
                // Right: Abstand vom rechten Rand der Text-Box zur Überlappung
                const insetRight = ((txt.right - overlapRight) / txt.width) * 100;
                // Bottom: Abstand vom unteren Rand der Text-Box zur Überlappung
                const insetBottom = ((txt.bottom - overlapBottom) / txt.height) * 100;
                // Left: Abstand vom linken Rand der Text-Box zur Überlappung
                const insetLeft = ((overlapLeft - txt.left) / txt.width) * 100;
                
                // ClipPath mit berechneten Insets und abgerundeten Ecken setzen
                textWhite.style.clipPath = 
                    'inset(' + insetTop + '% ' + insetRight + '% ' + insetBottom + '% ' + insetLeft + '% round ' + borderRadius + 'px)';
            }

            // Animation fortsetzen, solange Unterschied zwischen aktuell und Ziel besteht
            if (Math.abs(currentProgress - targetProgress) > 0.001) {
                requestAnimationFrame(updateAnimation);
            } else {
                // Animation beendet
                isAnimating = false;
            }
        };

        /**
         * Event-Handler für Scroll/Resize
         * Startet Animation nur, wenn sie nicht bereits läuft
         */
        const onScroll = () => {
            if (!isAnimating) {
                isAnimating = true;
                requestAnimationFrame(updateAnimation);
            }
        };

        // Event-Listener registrieren
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        
        // Initiale Animation starten
        updateAnimation();
    }

    /**
     * Scroll-Animation für .scroll-media-mask Sektionen:
     * Das Medium wächst beim Scrollen von einer kleinen, zentrierten Box am unteren Rand
     * auf die volle Viewport-Größe. Die weiße Text-Ebene wird per clip-path genau auf den
     * vom Medium verdeckten Bereich beschränkt, sodass der Text stets lesbar bleibt.
     *
     * Sektionen mit .scroll-media-split durchlaufen danach eine zweite Phase: der
     * zentrierte Text fährt nach oben weg, das Medium wandert nach rechts und links
     * fährt ein Textblock mit klickbaren Tabs ein (Wechsel: handleSplitMediaTabs)
     */
    private handleScrollVideoMask(): void {
        const sections = document.querySelectorAll<HTMLElement>('.scroll-media-mask');
        if (!sections.length) return;

        const easeInOutQuart = (t: number): number =>
            t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

        const lerp = (start: number, end: number, factor: number): number =>
            start + (end - start) * factor;

        const clamp01 = (value: number): number => Math.min(Math.max(value, 0), 1);

        // Länge der Phasen in Viewporthöhen, der Rest der Sektion bleibt zum Klicken
        // Bezug ist die Sektionshöhe aus tags.scss, dort steht der einzige Stellknopf
        const GROW_VH_DESKTOP  = 2;
        const GROW_VH_NARROW   = 1.5;
        const SPLIT_VH_DESKTOP = 1;
        const SPLIT_VH_NARROW  = 0.75;

        interface SectionState {
            section: HTMLElement;
            sticky: HTMLElement;
            bg: HTMLElement;
            textWhite: HTMLElement;
            textDark: HTMLElement;
            video: HTMLVideoElement | null;
            curve: HTMLElement | null;
            isSplit: boolean;
            splitText: HTMLElement | null;
            currentProgress: number;
            targetProgress: number;
        }

        const states: SectionState[] = [];
        sections.forEach(section => {
            const sticky  = section.querySelector<HTMLElement>('.scroll-media-sticky');
            const bg      = section.querySelector<HTMLElement>('.scroll-media-bg');
            const textDark = section.querySelector<HTMLElement>('.content-area');
            if (!sticky || !bg || !textDark) return;

            // Weiße Overlay-Kopie automatisch erzeugen (kein doppelter HTML-Block nötig)
            const textWhite = textDark.cloneNode(true) as HTMLElement;
            textWhite.classList.add('content-area-white');
            textWhite.setAttribute('aria-hidden', 'true');
            // Buttons auf white-Variante umstellen
            textWhite.querySelectorAll<HTMLElement>('.button').forEach(btn => {
                btn.classList.add('white');
            });
            // mask-hidden Klassen entfernen (weißer Text soll stets vollständig im DOM sein)
            textWhite.querySelectorAll<HTMLElement>('.mask-hidden').forEach(el => {
                el.classList.remove('mask-hidden');
            });
            sticky.appendChild(textWhite);
            // Sofort verstecken, damit kein Flash vor der ersten Animation entsteht
            textWhite.style.clipPath = 'inset(100% 0 0 0)';

            const video = bg.querySelector<HTMLVideoElement>('video');

            // Maske ("curved bottom") startet unterhalb des Viewport-Rands (versteckt)
            const curve = section.querySelector<HTMLElement>('.scroll-media-curve');
            if (curve) curve.style.transform = 'translateY(100%)';

            // Split Variante mit zweiter Phase, Medium rechts und Textblock links
            const isSplit   = section.classList.contains('scroll-media-split');
            const splitText = isSplit ? section.querySelector<HTMLElement>('.split-text') : null;

            states.push({ section, sticky, bg, textWhite, textDark, video, curve,
                isSplit, splitText,
                currentProgress: 0, targetProgress: 0 });
        });

        if (!states.length) return;

        let isAnimating = false;

        const updateAll = () => {
            const windowHeight = window.innerHeight;
            // Unter 992 px steht das Split Layout vertikal, Medium oben, Text darunter
            const isNarrow = window.matchMedia('(max-width: 991px)').matches;

            states.forEach(state => {
                const sectionRect = state.section.getBoundingClientRect();

                const stickyW = state.sticky.offsetWidth;
                const stickyH = state.sticky.offsetHeight;

                // Die Split Variante rechnet mit der Sticky Höhe statt window.innerHeight
                // Auf dem Handy ändert sich innerHeight, sobald die Browserleiste ein
                // oder ausfährt, dadurch springt der Fortschritt und die Maske flackert
                const viewportRef = state.isSplit ? stickyH : windowHeight;
                const scrollable = Math.max(sectionRect.height - viewportRef, 1);

                state.targetProgress = 0;
                if (sectionRect.top <= 0) {
                    state.targetProgress = Math.min(Math.abs(sectionRect.top) / scrollable, 1);
                }

                state.currentProgress = lerp(state.currentProgress, state.targetProgress, 0.1);

                // Phasengrenzen aus den Viewporthöhen ableiten
                const growVh  = isNarrow ? GROW_VH_NARROW  : GROW_VH_DESKTOP;
                const splitVh = isNarrow ? SPLIT_VH_NARROW : SPLIT_VH_DESKTOP;
                const growEnd  = clamp01(growVh * viewportRef / scrollable);
                const splitEnd = clamp01((growVh + splitVh) * viewportRef / scrollable);

                // Aufteilung vor dem Easing, damit die Wachstumsphase dieselbe Kurve
                // behält wie in der einfachen Variante
                const raw = state.currentProgress;
                const p = easeInOutQuart(state.isSplit ? clamp01(raw / Math.max(growEnd, 0.0001)) : raw);
                const tSplit = state.isSplit
                    ? easeInOutQuart(clamp01((raw - growEnd) / Math.max(splitEnd - growEnd, 0.0001)))
                    : 0;

                // Video wächst von 10 % Breite (16:9) auf volle Sticky-Größe
                const minW  = stickyW * 0.1;
                const minH  = minW * 0.5625;
                let currW = minW + (stickyW - minW) * p;
                let currH = minH + (stickyH - minH) * p;

                // Leichtes translateY: Video startet 100 % unterhalb des Bottoms
                const translateY  = 100 * (1 - p);
                let borderRadius = 16 * (1 - p);
                let offsetX = 0;
                let offsetY = 0;

                // Split Phase, der Rahmen schrumpft auf seine Zielgröße
                // Breit in die rechte Hälfte, schmal in die obere Hälfte
                if (tSplit > 0) {
                    const targetW = isNarrow ? stickyW * 0.9 : stickyW * 0.46;
                    // Breit läuft das Medium unten aus dem Bild, oben bleiben 12 %
                    let targetH = stickyH * 0.88;
                    // Oberkante des Rahmens im schmalen Layout
                    let frameTop = 0;

                    if (isNarrow) {
                        // Das Bild bekommt das Feld zwischen Textblock und Tabs
                        // Gemessen wird über offsetTop und offsetHeight, damit die
                        // Bewegung von .split-text die Werte nicht verfälscht
                        const panels = state.splitText?.querySelector<HTMLElement>('.split-text-panels');
                        const nav    = state.splitText?.querySelector<HTMLElement>('.split-text-nav');
                        const gap    = stickyH * 0.03;

                        const textBottom = panels
                            ? state.splitText!.offsetTop + panels.offsetTop + panels.offsetHeight
                            : stickyH * 0.35;
                        const navTop = nav
                            ? state.splitText!.offsetTop + nav.offsetTop
                            : stickyH * 0.86;

                        // Freies Feld zwischen Textblock und Tabs
                        const freeTop = textBottom + gap;
                        // Untergrenze, damit das Bild bei langem Text nicht verschwindet
                        const freeH = Math.max(navTop - gap - freeTop, stickyH * 0.2);

                        // Obergrenze, sonst füllt das Bild rund 57 % der Höhe
                        // und dominiert das Layout
                        targetH = Math.min(freeH, stickyH * 0.42);
                        // Im verbleibenden Feld zentrieren
                        frameTop = freeTop + (freeH - targetH) / 2;
                    }

                    currW = lerp(stickyW, targetW, tSplit);
                    currH = lerp(stickyH, targetH, tSplit);

                    // Der Rahmen ist unten und mittig verankert, von dort wird versetzt
                    if (isNarrow) {
                        offsetY = lerp(0, currH + frameTop - stickyH, tSplit);
                    } else {
                        offsetX = lerp(0, stickyW * 0.22, tSplit);
                        // Kein vertikaler Versatz, der Rahmen bleibt unten bündig
                        offsetY = 0;
                    }
                    borderRadius = lerp(0, 24, tSplit);
                }

                state.bg.style.width        = currW + 'px';
                state.bg.style.height       = currH + 'px';
                state.bg.style.transform    =
                    `translateX(calc(-50% + ${offsetX}px)) translateY(${translateY}%) translateY(${offsetY}px)`;
                // Läuft das Medium unten aus dem Bild, bleiben die Ecken dort eckig
                state.bg.style.borderRadius = (state.isSplit && !isNarrow && tSplit > 0)
                    ? `${borderRadius}px ${borderRadius}px 0 0`
                    : `${borderRadius}px`;

                // Video-Zoom: 125 % → 100 %
                if (state.video) {
                    const scale = 1.25 - (0.25 * p);
                    state.video.style.transform = `scale(${scale})`;
                }

                // Maske erst gegen Ende einblenden fährt bei ~80 %
                // Breite bleibt konstant nur die vertikale Position animiert.
                if (state.curve) {
                    const MASK_REVEAL_START = 0.8; // ab hier beginnt die Maske hochzukommen
                    const maskProgress = Math.min(
                        Math.max((p - MASK_REVEAL_START) / (1 - MASK_REVEAL_START), 0), 1);
                    state.curve.style.transform = `translateY(${100 * (1 - maskProgress)}%)`;
                    // In der Split Phase blendet die Maske mit dem Rahmen aus
                    if (state.isSplit) state.curve.style.opacity = String(1 - tSplit);
                }

                if (state.isSplit) {
                    // Zentrierter Text fährt nach oben weg und blendet aus
                    // Beide Ebenen bewegen sich gleich, sonst passt der clip-path der
                    // weißen Kopie nicht mehr und der Text springt auf die Themefarbe
                    const introShift   = `translateY(${-60 * tSplit}px)`;
                    const introOpacity = String(1 - tSplit);
                    const introVis     = tSplit >= 1 ? 'hidden' : 'visible';

                    [state.textDark, state.textWhite].forEach(layer => {
                        layer.style.transform  = introShift;
                        layer.style.opacity    = introOpacity;
                        layer.style.visibility = introVis;
                    });

                    // Textblock fährt ein, breit von links, schmal von unten
                    if (state.splitText) {
                        state.splitText.style.transform = isNarrow
                            ? `translateY(${60 * (1 - tSplit)}px)`
                            : `translateX(${-80 * (1 - tSplit)}px)`;
                        state.splitText.style.opacity      = String(tSplit);
                        state.splitText.style.pointerEvents = tSplit > 0.9 ? 'auto' : 'none';
                    }

                    // Maskenform je Tab erst im Split Zustand aktivieren
                    // An ab 0,2 und aus erst unter 0,05, damit die Form bei kleinen
                    // Schwankungen nicht zwischen Maske und Rechteck springt
                    const clipOn = state.sticky.classList.contains('split-active');
                    state.sticky.classList.toggle('split-active', clipOn ? tSplit > 0.05 : tSplit > 0.2);
                }

                // clip-path für weißen Text auf den Video-Überlappungsbereich setzen
                const bgRect  = state.bg.getBoundingClientRect();
                const txtRect = state.textDark.getBoundingClientRect();

                const overlapLeft   = Math.max(txtRect.left,  bgRect.left);
                const overlapRight  = Math.min(txtRect.right, bgRect.right);
                const overlapTop    = Math.max(txtRect.top,   bgRect.top);
                const overlapBottom = Math.min(txtRect.bottom, bgRect.bottom);

                if (overlapRight <= overlapLeft || overlapBottom <= overlapTop) {
                    state.textWhite.style.clipPath = 'inset(100% 0 0 0)';
                } else {
                    const iTop    = ((overlapTop    - txtRect.top)    / txtRect.height) * 100;
                    const iRight  = ((txtRect.right  - overlapRight)   / txtRect.width)  * 100;
                    const iBottom = ((txtRect.bottom - overlapBottom)  / txtRect.height) * 100;
                    const iLeft   = ((overlapLeft    - txtRect.left)   / txtRect.width)  * 100;
                    state.textWhite.style.clipPath =
                        `inset(${iTop}% ${iRight}% ${iBottom}% ${iLeft}% round ${borderRadius}px)`;
                }
            });

            const stillRunning = states.some(s => Math.abs(s.currentProgress - s.targetProgress) > 0.001);
            if (stillRunning) {
                requestAnimationFrame(updateAll);
            } else {
                isAnimating = false;
            }
        };

        const onScroll = () => {
            if (!isAnimating) {
                isAnimating = true;
                requestAnimationFrame(updateAll);
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });

        updateAll();
    }

    /**
     * Wechsel der Tabs im Split Layout (.scroll-media-split):
     * Beim Klick auf einen Tab fährt das Medium nach oben aus dem Rahmen und das
     * nächste kommt von unten nach, gleichzeitig fährt der bisherige Textblock nach
     * unten weg und der neue blendet ein
     */
    private handleSplitMediaTabs(): void {
        const sections = document.querySelectorAll<HTMLElement>('.scroll-media-split');
        if (!sections.length) return;

        // Passend zur längeren der beiden Keyframes in tags.scss
        // split-media-leave 0,9 s und split-media-enter 1,3 s
        const DURATION = 1350;

        sections.forEach(section => {
            const slides  = Array.from(section.querySelectorAll<HTMLElement>('.split-media-slide'));
            const panels  = Array.from(section.querySelectorAll<HTMLElement>('.split-text-panel'));
            const buttons = Array.from(section.querySelectorAll<HTMLButtonElement>('.split-text-nav button'));
            if (slides.length < 2 || !buttons.length) return;

            let activeIndex = 0;
            let isSwitching = false;

            // Setzt ein Element ohne sichtbare Bewegung in den Ausgangszustand zurück
            const resetInstantly = (el: HTMLElement) => {
                el.classList.add('is-instant');
                el.classList.remove('is-leaving');
                void el.offsetWidth; // Reflow erzwingen, damit die Transition nicht greift
                el.classList.remove('is-instant');
            };

            const switchTo = (index: number) => {
                if (isSwitching || index === activeIndex) return;
                if (!slides[index] || !panels[index]) return;

                isSwitching = true;

                const oldSlide = slides[activeIndex];
                const newSlide = slides[index];
                const oldPanel = panels[activeIndex];
                const newPanel = panels[index];

                // Altes Medium skaliert zurück und fährt nach oben aus dem Rahmen,
                // das neue kommt von unten nach und skaliert auf volle Größe
                oldSlide.classList.remove('is-active');
                oldSlide.classList.add('is-leaving');
                newSlide.classList.add('is-active', 'is-entering');

                // Alter Text fährt nach unten weg, der neue blendet versetzt ein
                oldPanel.classList.remove('is-active');
                oldPanel.classList.add('is-leaving');
                window.setTimeout(() => newPanel.classList.add('is-active'), 150);

                // Video nur im sichtbaren Slide laufen lassen
                oldSlide.querySelector('video')?.pause();
                newSlide.querySelector('video')?.play().catch(() => { /* Autoplay ggf. blockiert */ });

                buttons.forEach((btn, i) => {
                    btn.classList.toggle('is-active', i === index);
                    btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
                });

                activeIndex = index;

                window.setTimeout(() => {
                    // Slides laufen über Animationen, das Entfernen der Klasse genügt,
                    // sie gehen ohne sichtbare Bewegung in den Ruhezustand
                    oldSlide.classList.remove('is-leaving');
                    newSlide.classList.remove('is-entering');
                    resetInstantly(oldPanel);
                    isSwitching = false;
                }, DURATION);
            };

            buttons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const index = parseInt(btn.dataset.index || '', 10);
                    if (!isNaN(index)) switchTo(index);
                });
            });
        });
    }

    /**
     * Wechsel der Tabs in der Anforderungstabelle (.spec-table)
     * Ab Desktop ist nur der aktive Bereich sichtbar, darunter greift der CSS Expander
     */
    private handleSpecificationsTable(): void {
        document.querySelectorAll<HTMLElement>('.spec-table').forEach(table => {
            const buttons = Array.from(table.querySelectorAll<HTMLButtonElement>('.spec-table-tab'));
            const sections = Array.from(table.querySelectorAll<HTMLElement>('.spec-table-section'));
            if (!buttons.length || !sections.length) return;

            buttons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const index = parseInt(btn.dataset.index || '', 10);
                    if (isNaN(index) || !sections[index]) return;

                    buttons.forEach((b, i) => {
                        b.classList.toggle('is-active', i === index);
                        b.setAttribute('aria-selected', i === index ? 'true' : 'false');
                    });

                    sections.forEach((section, i) => {
                        section.classList.toggle('is-active', i === index);
                    });

                    // Ohne Einfahren, der Nutzer hat den Bereich selbst gewählt
                    sections[index].style.transition = 'none';
                    sections[index].classList.add('mask-shown');
                });
            });
        });
    }

    /**
     * Einblendung der Kaufen Buttons beim Wechsel von Produkt oder Laufzeit, wie auf lumion.com
     * Die Chips spielen ihre Einblendung über das SCSS von selbst, sobald ihre Kachel erscheint
     */
    private animatePricingContent(scope: ParentNode): void {
        scope.querySelectorAll<HTMLElement>('.term-plan-button .button')
            .forEach(button => this.animateBuyButton(button));
    }

    /**
     * Einblendung eines Kaufen Buttons wie auf lumion.com
     * Die Rahmenlinie zeichnet sich einmal herum, danach kommen Hintergrund und Beschriftung
     */
    private animateBuyButton(button: HTMLElement): void {
        // Nur sichtbare Buttons und ohne reduzierte Bewegung
        if (button.offsetParent === null || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        // Rahmenlinie, die Animation steht im SCSS und wird hier neu gestartet
        button.classList.remove('is-drawing');
        void button.offsetWidth;
        button.classList.add('is-drawing');
        button.addEventListener('animationend', () => button.classList.remove('is-drawing'), { once: true });

        // Hintergrund blendet ein, Kurve Power1 easeOut
        if (!button.classList.contains('outline')) {
            button.animate(
                [
                    { backgroundColor: 'transparent' },
                    { backgroundColor: getComputedStyle(button).backgroundColor }
                ],
                { duration: 500, delay: 250, easing: 'cubic-bezier(0.5, 1, 0.89, 1)', fill: 'backwards' }
            );
        }

        // Beschriftung steigt von unten in den Button, Kurve Power2 easeInOut
        const height = button.clientHeight;

        Array.from(button.children).forEach(child => {
            (child as HTMLElement).animate(
                [
                    { opacity: 0, transform: `translateY(${height}px)` },
                    { opacity: 1, transform: 'translateY(0)' }
                ],
                { duration: 600, delay: 250, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'backwards' }
            );
        });
    }

    /**
     * Gleitende Markierung in Produktumschalter und Laufzeitumschalter, wie auf lumion.com
     * Die Markierung liegt unter der gewählten Option, die Bewegung steht im SCSS
     */
    private handleSwitchIndicators(): void {
        const place = (indicator: HTMLElement, target: HTMLElement | null) => {
            if (!target || target.offsetParent === null) {
                return;
            }

            // Beim ersten Setzen springt die Markierung an ihren Platz, statt von links zu gleiten
            const first = indicator.offsetWidth === 0;
            if (first) {
                indicator.style.transition = 'none';
            }

            indicator.style.width = `${target.offsetWidth}px`;
            indicator.style.height = `${target.offsetHeight}px`;
            indicator.style.transform = `translate(${target.offsetLeft}px, ${target.offsetTop}px)`;

            if (first) {
                void indicator.offsetWidth;
                indicator.style.transition = '';
            }
        };

        // Produktumschalter, die Markierung folgt dem aktiven Produkt samt Farbe
        document.querySelectorAll<HTMLElement>('.product-switch').forEach(container => {
            const indicator = container.querySelector<HTMLElement>('.product-switch-indicator');
            if (!indicator) {
                return;
            }

            const update = () => {
                const active = container.querySelector<HTMLElement>('.product-switch-item.is-active');
                indicator.dataset.product = active?.dataset.product ?? '';
                place(indicator, active);
            };

            update();

            new MutationObserver(update).observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
            new ResizeObserver(update).observe(container);
        });

        // Laufzeitumschalter, auch der ausgeblendete des anderen Produkts
        document.querySelectorAll<HTMLElement>('.term-switch').forEach(fieldset => {
            const indicator = fieldset.querySelector<HTMLElement>('.term-switch-indicator');
            const options = fieldset.querySelector<HTMLElement>('.term-switch-options');
            if (!indicator || !options) {
                return;
            }

            const update = () => {
                const checked = fieldset.querySelector<HTMLInputElement>('.term-switch-input:checked');
                place(indicator, checked?.closest<HTMLElement>('.term-switch-option') ?? null);
            };

            update();

            fieldset.querySelectorAll<HTMLInputElement>('.term-switch-input')
                .forEach(input => input.addEventListener('change', update));
            new ResizeObserver(update).observe(options);
        });
    }

    private handleProductSwitch(): void {
        const container = document.querySelector<HTMLElement>('.product-switch');
        if (!container) {
            return;
        }

        const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>('.product-switch-item'));
        const panels = Array.from(document.querySelectorAll<HTMLElement>('.product-panel'));
        if (!buttons.length || !panels.length) {
            return;
        }

        const switchTo = (product: string) => {
            // Ohne passenden Bereich nichts verändern
            if (!panels.some(panel => panel.dataset.product === product)) {
                return;
            }

            buttons.forEach(btn => {
                const isActive = btn.dataset.product === product;
                btn.classList.toggle('is-active', isActive);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panels.forEach(panel => {
                panel.hidden = panel.dataset.product !== product;
            });

            const activePanel = panels.find(panel => panel.dataset.product === product);
            if (activePanel) this.animatePricingContent(activePanel);

            // Laufzeitumschalter des Bereichs
            let activeTerm = '';

            document.querySelectorAll<HTMLElement>('.term-switch-slot').forEach(slot => {
                const belongsToProduct = slot.dataset.product === product;
                slot.hidden = !belongsToProduct;

                if (belongsToProduct) {
                    // Laufzeit des Bereichs in die Adresszeile
                    activeTerm = slot.querySelector<HTMLInputElement>('.term-switch-input:checked')?.value ?? '';
                }
            });

            // replaceState ohne neuen Eintrag im Verlauf
            const url = new URL(window.location.href);
            url.searchParams.set('product', product);

            if (activeTerm) {
                url.searchParams.set('term', activeTerm);
            }

            window.history.replaceState(null, '', url.toString());

            // Höhen neu abgleichen, ausgeblendet waren sie null
            this.matchContainerHeight();
            this.matchContainerMinHeight();
        };

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                const product = btn.dataset.product;
                if (product) {
                    switchTo(product);
                }
            });
        });
    }

    /**
     * Aufklappbereich der Kachel Axogram Kostenlos
     * Mail und Programm wählen, danach startet der Download von lumion.com ohne Neuladen
     */
    private handleAxogramFreeDialog(): void {
        const dialog = document.querySelector<HTMLElement>('#axogram-free-dialog');
        const trigger = document.querySelector<HTMLButtonElement>('[data-axogram-free-open]');
        const email = document.querySelector<HTMLInputElement>('#axogram-free-email');
        if (!dialog || !trigger || !email) return;

        const form = dialog.querySelector<HTMLFormElement>('#axogram-free-form');
        const fields = dialog.querySelector<HTMLElement>('.axogram-free-fields');
        const send = dialog.querySelector<HTMLButtonElement>('[data-axogram-free-send]');
        const sendStatus = dialog.querySelector<HTMLElement>('.axogram-free-send-status');
        if (!form || !fields || !send || !sendStatus) return;

        const choices = Array.from(fields.querySelectorAll<HTMLInputElement>('input[type="radio"]'));
        const captcha = form.querySelector<HTMLElement>('.frc-captcha');

        // Ungelöste Captchas tragen einen Wert mit Punkt am Anfang, etwa .UNSTARTED
        const isCaptchaSolved = () => {
            if (!captcha) return true;
            const solution = captcha.querySelector<HTMLInputElement>('input[name="frc-captcha-solution"]');
            return !!solution && solution.value.length > 0 && !solution.value.startsWith('.');
        };

        // Eine Lösung gilt nur für eine Anfrage, danach muss das Puzzle neu starten
        const resetCaptcha = () => {
            (window as any).friendlyChallenge?.autoWidget?.reset();
        };

        // Absenden erst mit gültiger Adresse und einem Programm
        const updateSendState = () => {
            send.disabled = !email.checkValidity() || !choices.some(choice => choice.checked);
        };

        const positionDialog = () => {
            const button = trigger.getBoundingClientRect();
            const width = Math.min(button.width, window.innerWidth - 32);
            const below = window.innerHeight - button.bottom - 24;
            const above = button.top - 24;
            const openAbove = below < 300 && above > below;
            const maxHeight = Math.max(120, openAbove ? above : below);
            dialog.style.width = `${width}px`;
            dialog.style.left = `${Math.min(Math.max(16, button.left), window.innerWidth - width - 16)}px`;
            dialog.style.maxHeight = `${maxHeight}px`;
            dialog.style.top = openAbove
                ? `${Math.max(16, button.top - 8 - Math.min(dialog.scrollHeight, maxHeight))}px`
                : `${button.bottom + 8}px`;
        };

        const closeDialog = (restoreFocus: boolean) => {
            dialog.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
            if (restoreFocus) trigger.focus();
        };

        trigger.addEventListener('click', () => {
            if (!dialog.hidden) {
                closeDialog(false);
                return;
            }
            dialog.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
            positionDialog();
            email.focus({ preventScroll: true });
        });
        document.addEventListener('pointerdown', event => {
            if (!dialog.hidden && !dialog.contains(event.target as Node) && !trigger.contains(event.target as Node)) {
                closeDialog(false);
            }
        });
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && !dialog.hidden) closeDialog(true);
        });
        window.addEventListener('resize', () => {
            if (!dialog.hidden) positionDialog();
        });
        window.addEventListener('scroll', () => {
            if (!dialog.hidden) positionDialog();
        }, true);

        email.addEventListener('input', updateSendState);
        choices.forEach(choice => choice.addEventListener('change', updateSendState));
        updateSendState();

        // Versand im Hintergrund, der Aufklappbereich bleibt offen
        form.addEventListener('submit', async event => {
            event.preventDefault();

            if (!email.reportValidity()) return;
            if (!choices.some(choice => choice.checked)) return;

            if (!isCaptchaSolved()) {
                sendStatus.textContent = 'Bitte bestätigen Sie zuerst das Captcha.';
                positionDialog();
                return;
            }

            send.disabled = true;
            sendStatus.textContent = 'Der Download wird vorbereitet.';

            try {
                const response = await fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });

                const result = await response.json() as { ok?: boolean; message?: string; downloadUrl?: string };

                sendStatus.textContent = result.message ?? 'Der Download konnte nicht gestartet werden.';

                if (result.ok === true) {
                    // Danach nur Bestätigung und Hinweis
                    fields.hidden = true;
                    dialog.querySelectorAll<HTMLElement>('#axogram-free-title, #axogram-free-description')
                        .forEach(part => part.hidden = true);

                    if (result.downloadUrl) {
                        // Ersatzlink, falls der Browser den Download blockiert
                        const fallback = document.createElement('a');
                        fallback.href = result.downloadUrl;
                        fallback.rel = 'noopener';
                        fallback.textContent = 'Falls der Download nicht startet, klicken Sie hier.';
                        sendStatus.append(document.createElement('br'), fallback);

                        window.location.href = result.downloadUrl;
                    }
                } else {
                    resetCaptcha();
                    updateSendState();
                }
            } catch {
                sendStatus.textContent = 'Der Download konnte nicht gestartet werden. Bitte melden Sie sich direkt bei uns.';
                resetCaptcha();
                updateSendState();
            }

            positionDialog();
        });
    }

    /**
     * Wechsel der Laufzeit auf der Kaufen Seite
     * Je Laufzeit ein Preisblock, sichtbar ist nur der gewählte
     * Die Laufzeit steht in der Adresszeile, ohne Neuladen
     */
    private handleTermSwitch(): void {
        const areas = Array.from(document.querySelectorAll<HTMLElement>('.term-switch-area'));
        if (!areas.length) {
            return;
        }

        areas.forEach(area => {
            // Zuordnung zum Bereich über die Kennung des Umschalters
            const key = area.dataset.termSwitch;
            const panel = key
                ? document.querySelector<HTMLElement>(`.product-panel[data-product="${key}"]`)
                : null;

            // Ohne Bereich gilt er für die ganze Seite, etwa auf der Aktionsseite
            const scope: ParentNode = panel ?? document;

            const inputs = Array.from(area.querySelectorAll<HTMLInputElement>('.term-switch-input'));
            if (!inputs.length) {
                return;
            }

            const switchTo = (term: string) => {
                const cards = Array.from(scope.querySelectorAll<HTMLElement>('.product-price-container'));

                cards.forEach(card => {
                    const plans = Array.from(card.querySelectorAll<HTMLElement>('.term-plan'));

                    // Kacheln ohne Laufzeiten, etwa Custom, bleiben immer sichtbar
                    // Ihr Button spielt die Einblendung trotzdem, wie auf lumion.com
                    if (!plans.length) {
                        this.animatePricingContent(card);
                        return;
                    }

                    const match = plans.find(plan => plan.dataset.term === term);

                    // Ohne Produkt in dieser Laufzeit wird die Kachel ausgeblendet
                    const wasHidden = card.hidden;
                    card.hidden = !match;

                    plans.forEach(plan => {
                        plan.hidden = plan !== match;
                    });

                    if (match) this.animatePricingContent(wasHidden ? card : match);
                });

                // Spaltenzahl nach sichtbaren Kacheln
                scope.querySelectorAll<HTMLElement>('.product-container-area').forEach(area => {
                    const visible = Array.from(area.querySelectorAll<HTMLElement>('.product-price-container'))
                        .filter(card => !card.hidden).length;

                    if (visible > 0) {
                        area.style.setProperty('--counter', String(visible));
                    }
                });

                // replaceState ohne neuen Eintrag im Verlauf
                const url = new URL(window.location.href);
                url.searchParams.set('term', term);
                window.history.replaceState(null, '', url.toString());

                // Höhen neu abgleichen
                this.matchContainerMinHeight();
            };

            inputs.forEach(input => {
                input.addEventListener('change', () => {
                    if (input.checked && input.value) {
                        switchTo(input.value);
                    }
                });
            });
        });
    }

    /**
     * Schwebender Laufzeitumschalter in der mobilen Ansicht
     * Unter der Navigation bleibt er stehen und gleitet nach rechts
     * Am Ende der Sektion scrollt er mit weg
     */
    private handleStickyTermSwitch(): void {
        const docks = Array.from(document.querySelectorAll<HTMLElement>('.term-switch-dock'));
        if (!docks.length) {
            return;
        }

        // Gleiche Grenze wie im SCSS
        const narrow = window.matchMedia('(max-width: 1199px)');
        const header = document.querySelector<HTMLElement>('header');

        // Abstand zur Navigation und zum rechten Rand
        const gap = 12;

        let frame = 0;

        const update = () => {
            frame = 0;

            // Unterkante der festen Navigation
            const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
            const dockTop = headerBottom + gap;

            docks.forEach(dock => {
                const float = dock.querySelector<HTMLElement>('.term-switch-float');
                const section = dock.closest<HTMLElement>('section');

                // Ausgeblendete Umschalter überspringen
                if (!float || !section || dock.offsetParent === null) {
                    dock.classList.remove('is-sticky');
                    dock.removeAttribute('data-at-section-end');
                    return;
                }

                const rect = dock.getBoundingClientRect();
                const sectionBottom = section.getBoundingClientRect().bottom;
                const width = float.offsetWidth;
                const height = float.offsetHeight;

                // Am Ende der Sektion mit nach oben schieben
                const endTop = sectionBottom - height;
                const sticky = narrow.matches && rect.top <= dockTop && sectionBottom > 0;

                dock.style.setProperty('--toggle-width', `${width}px`);
                dock.style.setProperty('--toggle-height', `${height}px`);
                dock.style.setProperty('--toggle-left', `${rect.left}px`);
                dock.style.setProperty('--toggle-shift', `${document.documentElement.clientWidth - gap - rect.left - width}px`);
                dock.style.setProperty('--toggle-top', `${Math.min(dockTop, endTop)}px`);
                dock.toggleAttribute('data-at-section-end', endTop < dockTop);
                dock.classList.toggle('is-sticky', sticky);
            });
        };

        // Höchstens einmal je Bild rechnen
        const schedule = () => {
            if (!frame) {
                frame = window.requestAnimationFrame(update);
            }
        };

        update();

        // Reagiert auch auf den Wechsel des Produkts
        const observer = new ResizeObserver(schedule);
        docks.forEach(dock => {
            observer.observe(dock);

            const section = dock.closest<HTMLElement>('section');
            if (section) {
                observer.observe(section);
            }
        });

        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        narrow.addEventListener('change', schedule);
    }

    /**
     * Einblendung von Umschaltern und Kacheln wie auf lumion.com
     * Jede Gruppe gleitet einmal von unten ein, sobald sie ins Bild kommt
     * Beim Wechsel von Produkt oder Laufzeit wird nichts mehr animiert
     */
    private handleCardReveal(): void {
        const groups = [
            { container: '.product-switch-area', items: ':scope > .product-switch', delay: 240 },
            { container: '.term-switch-area', items: '.term-switch', delay: 320 },
            { container: '.product-container-area', items: ':scope > .product-price-container', delay: 400 }
        ];

        // Werte von lumion.com, die Kurve entspricht Power3 easeInOut
        const duration = 450;
        const stagger = 80;
        const offset = 50;
        const easing = 'cubic-bezier(0.76, 0, 0.24, 1)';

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const show = (items: HTMLElement[]) => items.forEach(item => item.classList.add('is-revealed'));

        groups.forEach(group => {
            const containers = Array.from(document.querySelectorAll<HTMLElement>(group.container));
            if (!containers.length) {
                return;
            }

            const itemsOf = (container: HTMLElement) => Array.from(container.querySelectorAll<HTMLElement>(group.items));

            // Ohne Bewegung sofort zeigen
            if (reduced) {
                containers.forEach(container => show(itemsOf(container)));
                return;
            }

            // Lädt die Seite schon weiter unten, erscheint der Inhalt ohne Animation
            if (window.scrollY > 0 && containers.some(container => container.offsetParent !== null && container.getBoundingClientRect().top < window.innerHeight)) {
                containers.forEach(container => show(itemsOf(container)));
                return;
            }

            const observer = new IntersectionObserver(entries => {
                const entry = entries.find(e => e.isIntersecting);
                if (!entry) {
                    return;
                }

                observer.disconnect();

                // Versetzt werden nur sichtbare Elemente
                itemsOf(entry.target as HTMLElement)
                    .filter(item => item.offsetParent !== null)
                    .forEach((item, index) => {
                        item.animate(
                            [
                                { opacity: 0, transform: `translateY(${offset}px)` },
                                { opacity: 1, transform: 'translateY(0)' }
                            ],
                            { duration, delay: group.delay + index * stagger, easing, fill: 'backwards' }
                        );

                        // Die Kaufen Buttons spielen dabei ihre eigene Einblendung
                        this.animatePricingContent(item);
                    });

                // Ausgeblendete Bereiche wie das andere Produkt erscheinen später ohne Animation
                containers.forEach(container => show(itemsOf(container)));
            });

            containers.forEach(container => observer.observe(container));
        });
    }

    /**
     * Setzt bei allen Elementen mit der Klasse .height-like-width die Höhe wie die Breite
     */
    private handleHeightLikeWidth() {
        const elements = document.querySelectorAll('.height-like-width');
        if (!elements) {
            return;
        }

        for (let i = 0; i < elements.length; i++) {
            const element = <HTMLElement>elements[i];

            this.setHeightLikeWidth(element);

            window.addEventListener('resize', () => this.setHeightLikeWidth(element));
        }
    }

    /**
     * Setzt bei diesem Element die Höhe wie die Breite
     */
    private setHeightLikeWidth(elem: HTMLElement): void {
        elem.style.height = elem.offsetWidth + 'px';
    }

    /**
     * Toggelt die anzeige der Preise für 1-Jahr und 3-Jahre Subscription
     */
    private handleReactTogglePrice() {
        const elements = document.querySelectorAll('.react-toggle-screenreader-only.price-toggle');
        if (!elements) {
            return;
        }

        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const id = element.getAttribute('data-id');
            if (!id) {
                continue;
            }
            const containerElem = document.getElementById(id);
            if (!containerElem) {
                continue;
            }

            element.addEventListener('input', (ev) => {
                const sub1 = containerElem.querySelectorAll('.sub-1');
                const sub3 = containerElem.querySelectorAll('.sub-3');

                if ((<HTMLInputElement>ev.target).checked) {
                    // 3 Jahre anzeigen
                    sub1?.forEach((x) => x.classList.remove('show'));
                    sub3?.forEach((x) => x.classList.add('show'));
                } else {
                    // 1 Jahr anzeigen
                    sub3?.forEach((x) => x.classList.remove('show'));
                    sub1?.forEach((x) => x.classList.add('show'));
                }
            });
        }
    }

    /*
     */
    public setSelectedUpgradeVersion(): string | null {
        let upgradeOptions = document.getElementsByName('upgradeOptions');
        let selectedOption;

        for (let tmpindex = 0; tmpindex < upgradeOptions.length; tmpindex++) {
            if ((<HTMLInputElement>upgradeOptions[tmpindex]).checked) {
                selectedOption = tmpindex;
                break;
            }
        }

        if (selectedOption !== null) {
            const selectedNumber: number = (selectedOption - 1) / 2;
            let hdVersionNumber = (<HTMLInputElement>document.getElementById('number_' + selectedNumber));

            if (hdVersionNumber !== null) {
                return hdVersionNumber.value;
            }
        }

        return null;
    }


    public updateSelectStyle(target: HTMLSelectElement) {
        if (!target.value) {
            target.classList.add("empty");
        } else {
            target.classList.remove("empty");
        }
    }


    public updateHeader() {
        let isMobile = window.innerWidth <= 767;
        if (document.querySelector('body>nav')) {
            let navHeight = document.querySelector('body>nav')?.clientHeight;

            if (this.headerPositionTop && navHeight) {
                if (isMobile || window.pageYOffset > this.headerPositionTop - navHeight) {
                    document.querySelector('#fixedHeader')?.classList.add("sticky");
                } else {
                    document.querySelector('#fixedHeader')?.classList.remove("sticky");
                }
            }

            // Nur für Index
            const indexElement = <HTMLElement>document.querySelector('.index');
            if (this.indexPositionTop != null && indexElement && !isMobile && window.pageYOffset > this.indexPositionTop) {
                let navHeight = (document.querySelector('body>nav')?.clientHeight || 72) * 2;
                indexElement.style.top = Math.max(window.pageYOffset + navHeight, 0) + "px";
            }
        }
    }


    public updateCategories() {
        let cat = document.location.hash.length > 0 ? document.location.hash.slice(1) : "all";
        const categoryAll = document.querySelectorAll('.category');

        for (let i = 0; i < categoryAll.length; i++) {
            const element = <HTMLElement>categoryAll[i];
            if (element.classList.contains(cat)) {
                element.style.display = "block";
                element.classList.remove('hide');
            }
            else {
                element.classList.add('hide');
            }
        }

        const noLinkAll = document.querySelectorAll('.nolink');
        for (let i = 0; i < noLinkAll.length; i++) {
            const element = <HTMLElement>noLinkAll[i];
            const a = element.getAttribute("href");
            if (a !== null && a.indexOf(cat) > -1) {
                element.classList.add("selected");
            }
            else {
                element.classList.remove("selected");
            }
        }
    }


    public updateLogo() {
        // if (location.href.indexOf("Backend") === - 1) {
        //     // Nicht aufm Smartphone
        //     if (window.innerWidth <= 991) {
        //         document.querySelector('.logo').style.height = "";
        //         if (document.querySelector('.puplisher-logo')) {
        //             document.querySelector('.puplisher-logo').style.marginTop = 0 + "px";
        //         }
        //         this.logoState = "m";
        //         return;
        //     } else if (this.logoState === "m") {
        //         document.querySelector('.logo').style.height = this.logoSize + "px";
        //         if (document.querySelector('.puplisher-logo')) {
        //             document.querySelector('.puplisher-logo').style.marginTop = this.logo2Margin + "px";
        //         }
        //         this.logoState = "b";
        //     }

        //     let y = window.pageYOffset ? window.pageYOffset : window.pageYOffset;
        //     if (y === 0 && this.logoState === "s") {
        //         document.querySelector('.logo').style.height = this.logoSize + "px";
        //         if (document.querySelector('.puplisher-logo')) {
        //             document.querySelector('.puplisher-logo').style.marginTop = this.logo2Margin + "px";
        //         }
        //         this.logoState = "b";
        //     } else if (y > 0 && this.logoState === "b") {
        //         document.querySelector('.logo').style.height = this.logoSize / 2 + "px";
        //         if (document.querySelector('.puplisher-logo')) {
        //             document.querySelector('.puplisher-logo').style.marginTop = 0 + "px";
        //         }
        //         this.logoState = "s";
        //     }
        // }
    }


    public updateRegions() {
        let country = document.querySelector<HTMLInputElement>("[id$='Land'], [id$='Country'], [id$='CountryCode']");
        if (country) {
            const selectFilteredOptionAll = document.querySelectorAll('select.filtered option');
            for (let i = 0; i < selectFilteredOptionAll.length; i++) {
                const element = <HTMLElement>selectFilteredOptionAll[i];
                if (!country.value) {
                    element.hidden = false;
                }
                else if (element.getAttribute("data-c") === country.value || element.getAttribute("data-c") === "ALL") {
                    element.hidden = false;
                }
                else {
                    element.hidden = true;
                }
            }
        }
    }

    public updateBillingType(e: Event) {
        let target = <HTMLInputElement>e.target;
        const lastschriftOption = <HTMLElement>document.querySelector('#lastschriftOption');
        if ((target.value === "Lastschrift" && target.checked)) {
            lastschriftOption.hidden = false;
        }
        else {
            lastschriftOption.hidden = true;
        }
    }

    public calculateHeight(element: HTMLElement[], calcWithGap: boolean) {
        if (!element) {
            return false;
        }
        var gap = false;
        if (calcWithGap) {
            gap = calcWithGap;
        }

        setTimeout(() => {
            if (element.length === 0) {
                return false;
            }

            var height = 0;
            for (let i = 0; i < element.length; i++) {
                const el = element[i];
                el.removeAttribute('style')
            }

            for (var i = 0; i < element.length; i++) {
                //var newHeight = parseInt($(element[i]).css('height'));
                var newHeight = element[i].offsetHeight;
                if (height < newHeight) {
                    height = newHeight;
                };
            }

            if (height > 0) {
                if (gap) {
                    height += 15;
                }
                for (let i = 0; i < element.length; i++) {
                    const el = element[i];
                    el.style.height = height + "px";
                }
            }
        }, 100);
    }

    public initDiscount() {
        const radioDiscountTypeAll = document.querySelectorAll('.radioDiscountType');
        if (!radioDiscountTypeAll || radioDiscountTypeAll.length == 0) {
            return;
        }
        var disabled = document.querySelector('.discountType.discountPrice');
        var required = document.querySelector('.discountType.discountPercentage');
        var checked = document.querySelector('.radioDiscountType.isDiscountPercentage');

        const b = document.querySelector<HTMLInputElement>('.discountType.discountPrice');
        if (b && parseFloat(b.value) > 0) {
            disabled = document.querySelector('.discountType.discountPercentage');
            required = document.querySelector('.discountType.discountPrice')
            checked = document.querySelector('.radioDiscountType.isDiscountPrice');
        }
        disabled?.setAttribute('disabled', 'disabled');
        required?.setAttribute('required', 'required');
        checked?.setAttribute('checked', 'checked');

        const radioAll = document.querySelectorAll('.radioDiscountType');
        for (let i = 0; i < radioAll.length; i++) {
            const element = <HTMLInputElement>radioAll[i];
            if (!element.parentElement) {
                continue;
            }

            element.parentElement.addEventListener('click', () => {
                const discountTypeAll = document.querySelectorAll('.discountType');
                for (let j = 0; j < discountTypeAll.length; j++) {
                    const elementDiscountType = <HTMLElement>discountTypeAll[j];

                    elementDiscountType.removeAttribute('disabled');
                    elementDiscountType.removeAttribute('required');
                    elementDiscountType.classList.remove('input-validation-error');

                }
                var cl = "discountPercentage";
                var cl2 = "discountPrice";
                if (element.classList.contains('isDiscountPercentage')) {
                    cl = "discountPrice";
                    cl2 = "discountPercentage";
                }
                document.querySelector('.discountType.' + cl)?.setAttribute('disabled', 'disabled');
                document.querySelector('.discountType.' + cl2)?.setAttribute('required', 'required');
            });

        }

        // document.querySelectorAll(('.radioDiscountType').forEach((i, el) => el.onclick = (e) => {
        //     document.querySelectorAll(('.discountType').forEach((i, el) => el.removeAttribute('disabled'));
        //     document.querySelectorAll(('.discountType').forEach((i, el) => el.removeAttribute('required'))
        //     document.querySelectorAll(('.discountType').forEach((i, el) => el.classList.remove('input-validation-error'));
        //     var cl = "discountPercentage";
        //     var cl2 = "discountPrice";
        //     if (el.classList.contains('isDiscountPercentage')) {
        //         cl = "discountPrice";
        //         cl2 = "discountPercentage";
        //     }
        //     document.querySelector('.discountType.' + cl).setAttribute('disabled', 'disabled');
        //     document.querySelector('.discountType.' + cl2).setAttribute('required', 'required');
        // });

    }

    /**
     * Multipliziert den Preis mit der Anzahl der Lizenzen
     * - #4514 Mengenrabatt am 24.11.2022 entfernt
     * @param ev 
     */
    public updatePrice(ev: Event) {
        let qnt = parseInt((<HTMLInputElement>(ev.currentTarget || ev.target)).value);

        if (qnt < 1 || isNaN(qnt)) {
            (<HTMLInputElement>(ev.currentTarget || ev.target)).value = '1';
            qnt = 1;
        }

        const priceBaseAll = document.querySelectorAll('.priceBase');
        for (let i = 0; i < priceBaseAll.length; i++) {
            const element = <HTMLElement>priceBaseAll[i];
            const priceOriginal = element.getAttribute('data-poriginal');
            const priceNetto = element.getAttribute('data-pnetto');
            const isUpgrade = element.getAttribute('data-isupgrade');
            const singlePrice = element.getAttribute('data-singleprice')
            let orgPrice: number;
            if (priceOriginal && priceNetto) {
                // Subscription:
                // Wenn ein Original- und ein Nettopreis vorhanden ist, dann kosten die Lizenzen
                // alle den Nettopreis
                const pn = parseFloat(priceNetto.replace('.', '').replace(' ', '').replace(',', '.'));

                orgPrice = pn * qnt;

            } else if (singlePrice) {
                const sp = parseFloat(singlePrice.replace('.', '').replace(' ', '').replace(',', '.'));

                orgPrice = sp * qnt;
            } else {
                orgPrice = this.priceBase[element.id] * qnt;
            }

            const finalPrice = orgPrice;

            let newPrice = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(finalPrice) + " €";
            element.innerText = newPrice;
        }
    }

    /** Prüft, ob das reCaptcha erlaubt wurde -> Zur Prüfung im Backend */
    // private handleRecaptcha(): void {
    //     const elem = <HTMLInputElement>document.getElementById('CheckRecaptcha');

    //     if (elem == null) {
    //         return;
    //     }

    //     const listCookies = document.cookie.split('; ');

    //     let recaptchaValue = 'false';
    //     const cookieRecaptcha = 'cct-reCAPTCHA';

    //     for (let i = 0; i < listCookies.length; i++) {
    //         const cookie = listCookies[i];

    //         if (cookie.indexOf(cookieRecaptcha) == 0) {
    //             const cookieSingle = cookie.split('=');
    //             recaptchaValue = cookieSingle[1];
    //         }
    //     }

    //     elem.value = recaptchaValue;
    // }

    /**
     * Hinterlegt den EventListener für die Interaktion der Sterne für eine neue Bewertung
     */
    private handleNewCustomerReview() {
        // Identifiziert die Sterne, die für die Bewertung geklickt werden sollen
        var starAreaElements = document.getElementsByClassName('select-review-stars');
        if (!starAreaElements) {
            return;
        }

        for (let i = 0; i < starAreaElements.length; i++) {
            const singleStarAreaElement = starAreaElements[i];
            // ID des Ziel Inputs (hidden), welches die gewählten Sterne transportiert
            const hiddenStarElementId = singleStarAreaElement.getAttribute('data-hiddenstar');
            if (!hiddenStarElementId) {
                continue;
            }

            // Findet Parent Element der Sterne
            const stars = singleStarAreaElement.getElementsByClassName('rating-stars-area');
            if (!stars) {
                return;
            }

            const starArea = stars[0].getElementsByTagName('span');

            // Pro Stern wird ein Click-EventListener angehängt
            for (let j = 0; j < starArea.length; j++) {
                const singleStar = starArea[j];

                singleStar.addEventListener('click', () => this.setCustomerReviewStar(singleStar, starArea, hiddenStarElementId));
            }

        }
    }

    /**
     * Regelt den Ablauf der Sterne-Bewertung, wenn ein Stern geklickt wird
     * @param singleStar Stern Image
     * @param hiddenStarElementId Ziel Input Id des Werts
     */
    private setCustomerReviewStar(singleStar: HTMLElement, starArea: HTMLCollectionOf<HTMLElement>, hiddenStarElementId: string): void {

        const inputStars = document.getElementById(hiddenStarElementId);
        if (!inputStars) {
            return;
        }
        const selectedStarValue = singleStar.getAttribute('data-star');

        if (!selectedStarValue) {
            return;
        }

        // Setzt den Sterne-Wert
        (<HTMLInputElement>inputStars).value = selectedStarValue;

        // Anzeige austauschen
        var showedItem = document.getElementById('selected-review-stars');
        if (showedItem) {
            const desc = ' Stern' + (parseInt(selectedStarValue, 10) > 1 ? 'e' : '');
            showedItem.innerText = selectedStarValue + desc;
        }

        // CSS Klassen für alle Sterne entsprechend anpassen
        for (let i = 0; i < starArea.length; i++) {
            const starElem = starArea[i];

            const starValue = starElem.getAttribute('data-star');
            const classList = starElem.classList;

            classList.remove('selected');
            if (starValue !== null && parseInt(starValue, 10) <= parseInt(selectedStarValue, 10)) {
                classList.add('selected');
            }
        }
    }

    /**
     * Lässt die Bewertungen auf der Startseite nach und nach durchlaufen
     */
    private handleCustomerReviewStart(): void {
        const listReviews = document.getElementsByClassName('container-customer-review');
        if (!listReviews || listReviews.length === 0) {
            return;
        }

        const countReviews = listReviews.length;

        // Random Liste (Reihenfolge der Rezensionen)
        const listRandom: number[] = new Array<number>();
        let counter = 0;
        while (counter < countReviews) {
            listRandom.push(this.getRandom(listRandom, countReviews));
            counter++;
        }

        // Setzt den Random Index auf als data-Attribut
        let selectedElement: HTMLElement;
        for (let i = 0; i < listReviews.length; i++) {
            const element = <HTMLElement>listReviews[i];

            element.setAttribute('data-sort', (listRandom[i] - 1).toString());

            // Erstes Aktives Element
            if (element.classList.contains('active')) {
                selectedElement = element;
            }
        }

        // Interval Aufruf für den Wechsel der Kundenbewertungen auf der Startseite
        this.startCustomerReviewInterval();

        // Mouse Events, um den Interval bei Hover anzuhalten
        for (let i = 0; i < listReviews.length; i++) {
            const element = listReviews[i];

            // Hover stoppt Interval
            element.addEventListener('mouseenter', () => {
                clearInterval(this._timerIdCustomerReview);
            });

            // Beim Verlassen des Elements wird der Interval neu angestoßen
            element.addEventListener('mouseleave', () => this.startCustomerReviewInterval());
        }
    }

    /**
     * Regelt den Interval für den Wechsel der Kundenbewertungen auf der Startseite
     */
    private startCustomerReviewInterval(): void {
        // Prüfen, ob die Elemente auf dieser Seite vorhanden sind
        const currentList = document.getElementsByClassName('container-customer-review');
        if (!currentList || currentList.length <= 1) {
            return;
        }

        // Wechsel der Bewertungen
        let timeout = 8000;
        this._timerIdCustomerReview = setInterval(() => {
            const currentList = document.getElementsByClassName('container-customer-review');

            const countReviews = currentList.length;
            let lastActiveIndex: number = 0;

            // Letztes aktives Element finden
            for (let j = 0; j < currentList.length; j++) {
                const element = currentList[j];

                element.classList.remove('inactive');

                if (element.classList.contains('active')) {
                    // Sort-Index
                    const sort = element.getAttribute('data-sort') || '0';
                    lastActiveIndex = parseInt(sort, 10);
                    // aktive CSS Klasse entfernen
                    element.classList.remove('active');
                    element.classList.add('inactive')
                }
            }

            // Nächster Index
            let nextIndex = lastActiveIndex + 1;
            if (nextIndex >= countReviews) {
                // Letzten abfangen und wieder von vorne anfangen
                nextIndex = 0;
            }

            // Aktiviert das nächste Element
            for (let j = 0; j < currentList.length; j++) {
                const element = currentList[j];

                const sort = element.getAttribute('data-sort');
                if (sort !== null && parseInt(sort, 10) === nextIndex) {
                    element.classList.add('active');

                    break;
                }

            }
        }, timeout); // 6 Sekunden Anzeige + 2 Sekunden Delay aus CSS
    }

    /**
     * Gibt eine Random Zahl zurück, die maximal die Anzahl der Reviews ist und noch nicht im number Array vorkommt
     * @param list Random number Liste
     * @param countReviews Anzahl der Reviews
     */
    private getRandom(list: number[], countReviews: number): number {
        let randomIndex = Math.floor(Math.random() * countReviews) + 1;
        if (list.indexOf(randomIndex) >= 0) {
            randomIndex = this.getRandom(list, countReviews);
        }
        return randomIndex;
    }

    /**
     * Hebt die geklickte Rezension auf der Übersicht hervor
     */
    private highlightSelectedCustomerReview(): void {
        // Prüfen, ob die Kundenbewertung Übersicht vorhanden ist
        const elements = document.getElementsByClassName('customer-review-area');
        if (!elements || elements.length === 0) {
            return;
        }

        // URL splitten und Anchor suchen
        const urlArr = document.URL.split('#');
        const anchor = urlArr[1];
        if (!anchor) {
            return;
        }

        // Element finden
        const selectedElement = document.getElementById(anchor);
        if (!selectedElement) {
            return;
        }
    }

    /** Confirm, ob der Datensatz tatsächlich DSGVO-konform gelöscht werden soll */
    private handleDSGVOdelete(): void {
        const button = document.getElementById('delete-dsgvo');
        if (!button) {
            return;
        }

        (<HTMLElement>button).addEventListener('click', (ev) => {

            if (confirm('Durch diesen Löschvorgang werden alle Kundendaten, Bestellungen und weitere Vorkommnisse dieses Kunden DSGVO-konform entfernt. Fortfahren?')) {
                // Löschvorgang durchführen
                return true;
            }
            ev.stopPropagation();
            ev.preventDefault();

            // nicht löschen
        });
    }

    /** Setzt alle importierten Zeilen auf gesetzt */
    public importSelectAllRows(ev: MouseEvent): void {
        ev.stopPropagation();
        ev.preventDefault();

        var form = document.getElementById('import-form');
        if (!form) {
            return;
        }

        var rows = form.getElementsByTagName('tr');

        console.log(rows);

        // Setzt jede Zeile auf gesetzt
        for (var i = 0; i < rows.length; i++) {
            var checkbox = document.getElementById("ImportData_" + i + "__IsChecked") as HTMLInputElement;
            if (!checkbox || checkbox.disabled) {
                continue;
            }
            checkbox.checked = true;
            checkbox.value = 'true';
        }

        this.setImportCounter();
    }

    /** Setzt alle importierten Zeilen auf ungesetzt */
    public importDeSelectAllRows(ev: MouseEvent): void {
        ev.stopPropagation();
        ev.preventDefault();

        var form = document.getElementById('import-form');
        if (!form) {
            return;
        }

        var rows = form.getElementsByTagName('tr');

        // Setzt jede Zeile auf ungesetzt
        for (var i = 0; i < rows.length; i++) {
            var checkbox = document.getElementById("ImportData_" + i + "__IsChecked") as HTMLInputElement;
            if (!checkbox) {
                continue;
            }
            checkbox.checked = false;
            checkbox.value = 'false';
        }

        this.setImportCounter();
    }

    public setImportCounter(): void {
        var form = document.getElementById('import-form');
        if (!form) {
            return;
        }

        var counter = document.getElementById('count-imports');
        if (!counter) {
            return;
        }

        const elements = form.querySelectorAll('input[type=checkbox]');
        if (!elements) {
            return;
        }

        let ctr = 0;
        for (let i = 0; i < elements.length; i++) {
            const element = <HTMLInputElement>elements[i];
            if (element.checked) {
                ctr++;
            }
        }

        counter.innerText = ctr.toString();
    }


    /** Handlet alle Klicks auf data-close Elemente */
    private handleClickEvents(): void {
        const elementsNavbarToggler = document.getElementsByClassName('navbar-toggler');
        if (elementsNavbarToggler) {
            for (let index = 0; index < elementsNavbarToggler.length; index++) {
                const elem = elementsNavbarToggler[index];

                elem.addEventListener('click', () => this.toggleNavbar(<HTMLElement>elem));

            }
        }

        const elements = document.getElementsByClassName('close');
        if (elements) {
            for (let index = 0; index < elements.length; index++) {
                const elem = elements[index];

                elem.addEventListener('click', () => this.close(<HTMLElement>elem));
            }
        }

        const elementsButtonJobs = document.getElementsByClassName('toggle-overlay-jobs');
        if (elementsButtonJobs) {
            for (let index = 0; index < elementsButtonJobs.length; index++) {
                const elem = elementsButtonJobs[index];

                elem.addEventListener('click', () => {
                    const el = document.getElementById('overlay-jobs');
                    if (el) {
                        el.classList.toggle('show');
                    }
                });
            }
        }

        const elementsToggle = document.querySelectorAll('[data-toggle]');
        if (elementsToggle) {
            for (let index = 0; index < elementsToggle.length; index++) {
                const elem = elementsToggle[index] as HTMLElement;
                const ziel = elem.getAttribute('data-toggle');

                if (!ziel) {
                    return;
                }

                elem.addEventListener('click', () => {
                    const el = document.getElementById(ziel);
                    if (el) {
                        el.classList.toggle('show');
                    }
                    if (elem.classList.contains('mehr-weniger')) {
                        const isOpen = el?.classList.contains('show');
                        if (isOpen) {
                            elem.innerText = 'Weniger ...';
                        } else {
                            elem.innerText = 'Mehr ...';
                        }
                    }
                });
            }
        }

        const elementImportSelectAll = document.getElementById('import-select-all');
        if (elementImportSelectAll) {
            elementImportSelectAll.addEventListener('click', (ev) => this.importSelectAllRows(ev));
        }

        const elementImportDeselectAll = document.getElementById('import-deselect-all');
        if (elementImportDeselectAll) {
            elementImportDeselectAll.addEventListener('click', (ev) => this.importDeSelectAllRows(ev));
        }

        const elementsImportClickSingle = document.getElementsByClassName('import-click-single');
        if (elementsImportClickSingle) {
            for (let index = 0; index < elementsImportClickSingle.length; index++) {
                const elem = elementsImportClickSingle[index];

                elem.addEventListener('click', () => this.setImportCounter());
            }
        }

        // Import Button prevent double-click
        const elemImportButton = document.getElementById('button-import-act3d');
        if (elemImportButton) {
            if ((<HTMLButtonElement>elemImportButton).disabled === false) {
                elemImportButton.addEventListener('click', () => {
                    // Button wird ausgeblendet, um Mehrfachklicks und somit Mehrfachimports zu unterbinden
                    (<HTMLButtonElement>elemImportButton).style.visibility = 'hidden';
                });
            }
        }

    }

    /** Schließt ein Fenster */
    private close(elem: HTMLElement): void {
        const id = elem.getAttribute('[data-close]');
        if (!id) {
            return;
        }
        const parent = document.getElementById(id);
        if (parent) {
            parent.remove();
        }
    }

    /** Prüft auf Input-Autocompletes und filtert die Liste bei der Suche */
    private handleAutocomplete(): void {
        const autocompleteAreas = document.querySelectorAll('.autocomplete-area');
        if (!autocompleteAreas.length) {
            return;
        }

        for (let j = 0; j < autocompleteAreas.length; j++) {
            const area = autocompleteAreas[j];

            // Ziel-Input (hidden)
            const inputAim = <HTMLInputElement>area.querySelector('.autocomplete-input-aim');
            // Such-Input
            const inputSearch = <HTMLInputElement>area.querySelector('.autocomplete-input-search');
            if (!inputAim || !inputSearch) {
                return;
            }

            // Alle Optionen
            const listOptions = area.querySelectorAll('[data-autocomplete-key]');

            // Click außerhalb der Liste schließt ebendiese
            document.addEventListener('click', (ev: MouseEvent) => {
                const isClickOutsideElement = (<HTMLDivElement>ev.target).contains(area);
                if (isClickOutsideElement) {
                    if (!inputAim.value) {
                        // Wenn keine Auswahl getroffen wurde, dann Feld leeren
                        inputSearch.value = '';
                    } else {
                        // Auflistung nach Key durchsuchen um zu verifizieren, dass das richtige Value ausgegeben wird
                        for (let i = 0; i < listOptions.length; i++) {
                            const element = listOptions[i];
                            if (element.getAttribute('data-autocomplete-key') == inputAim.value) {
                                inputSearch.value = element.getAttribute('data-autocomplete-value') || '';
                            }
                        }

                        // Wenn kein Value für den hinterlegten Key gefunden wurde, dann Feld leeren
                        if (!inputSearch.value) {
                            inputAim.value = '';
                        }
                    }

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                }
            });


            if (!listOptions.length) {
                return;
            }
            for (let i = 0; i < listOptions.length; i++) {
                const element = <HTMLDivElement>listOptions[i];
                element.addEventListener('click', () => {
                    const val = element.getAttribute('data-autocomplete-key');
                    inputAim.value = val || '';
                    inputSearch.value = element.innerText;

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                });

            }

            // Input Suche - Click Event
            inputSearch.addEventListener('click', (ev: MouseEvent) => {
                area.querySelector('.autocomplete-items')?.classList.add('open');
            });

            // Default Option, wenn kein Treffer gefunden wurde
            const defaultOption = <HTMLDivElement>area.querySelector('.option.default');
            if (defaultOption) {
                defaultOption.addEventListener('click', () => {
                    inputAim.value = '-1';
                    inputSearch.value = defaultOption.innerText;

                    area.querySelector('.autocomplete-items')?.classList.remove('open');
                });
            }

            // Input Suche - Keyup Event
            inputSearch.addEventListener('keyup', (ev: KeyboardEvent) => {

                if (!listOptions.length) {
                    return;
                }
                const inputAC = <HTMLInputElement>inputSearch;
                const searchString = inputAC.value.toLowerCase();
                const searchStringLength = searchString.length;

                // Sichtbarkeit Optionen
                for (let i = 0; i < listOptions.length; i++) {
                    const optionElement = <HTMLElement>listOptions[i];
                    const optionValue = optionElement.innerText;

                    // Zusatz Filterinformationen (bspw. College: Stadt)
                    const optionValueAddition = optionElement.getAttribute('data-autocomplete-additionalValue');

                    const foundInValueAddition = optionValueAddition && optionValueAddition.toLowerCase().indexOf(searchString) >= 0;

                    const idxStart = optionValue.toLowerCase().indexOf(searchString);
                    if ((idxStart < 0 && foundInValueAddition === false) || !inputAC.value.length) {
                        // -> Suchstring nicht gefunden
                        if (!inputAC.value.length) {
                            // Leerer Suchstring
                            optionElement.classList.remove('hidden');
                        } else {
                            // Klasse 'hidden' setzen
                            optionElement.classList.add('hidden');
                        }
                        optionElement.classList.remove('hit');
                        // Plain-Text setzen
                        optionElement.innerText = optionValue;
                    } else {
                        // -> Suchstring gefunden

                        // Klasse 'hidden' entfernen
                        optionElement.classList.remove('hidden');
                        optionElement.classList.add('hit');

                        const stringOriginal = optionValue.substring(idxStart, idxStart + searchStringLength);

                        // Text vor dem Suchstring
                        let textHighlighted = '';

                        // Nur highlighten, wenn der Suchstring im Value vorkommt -> wenn er nur in ValueAdditional vorkommt, dann kein Highlighting
                        if (idxStart >= 0) {
                            if (idxStart > 0) {
                                textHighlighted += optionValue.substring(0, idxStart);
                            }

                            // Suchstring (hervorgehoben)
                            textHighlighted += '<b>' + stringOriginal + '</b>';

                            // Text nach dem Suchstring
                            textHighlighted += optionValue.substring(idxStart + searchString.length);
                        }

                        // HTML-Text setzen
                        optionElement.innerHTML = textHighlighted || optionValue;
                    }
                }

                // Prüfen, ob überhaupt ein Treffer da ist
                const anyHits = area.querySelectorAll('[data-autocomplete-value].hit');
                if (defaultOption) {
                    if (!anyHits?.length) {
                        // Keine Treffer -> Sonstiges
                        defaultOption.classList.add('show');
                    } else {
                        // Treffer -> kein Default
                        defaultOption.classList.remove('show');
                    }
                }


                // Sichtbarkeit Option-Groups
                const listOptionGroup = area.getElementsByClassName('option-group');
                if (!listOptionGroup) {
                    return;
                }
                for (let i = 0; i < listOptionGroup.length; i++) {
                    const element = listOptionGroup[i];
                    const resultsHit = element.querySelectorAll('[data-autocomplete-value].hit');

                    if (!resultsHit.length && inputAC.value.length) {
                        element.classList.add('hidden');
                    } else {
                        element.classList.remove('hidden');
                    }

                }
            })

        }
    }


    /**
     * Öffnet/Schließt die Navigation in der mobilen Ansicht
     */
    public toggleNavbar(button: HTMLElement) {
        // aktuellen expanded-Zustand holen
        const isExpanded = button.getAttribute('data-expanded');

        const navBar = document.getElementById('nav1');
        if (!navBar) {
            return;
        }
        navBar.classList.toggle('expanded');
        navBar.removeAttribute('style');

        // data-expanded ändern
        button.setAttribute('data-expanded', (!isExpanded || isExpanded === 'false' ? 'true' : 'false'));
    }

    /**
     * Prüft, ob Countdowns vorhanden sind und aktiviert diese
     */
    private handleCountdown(): void {
        const elems = document.getElementsByClassName('countdown');
        if (!elems) {
            return;
        }

        for (let i = 0; i < elems.length; i++) {
            const elem = elems[i];
            const year = parseInt(elem.getAttribute('data-year') || '0', 10);
            const month = parseInt(elem.getAttribute('data-month') || '0', 10);
            const days = parseInt(elem.getAttribute('data-days') || '0', 10);
            const hours = parseInt(elem.getAttribute('data-hours') || '0', 10);
            const minutes = parseInt(elem.getAttribute('data-minutes') || '0', 10);
            const seconds = parseInt(elem.getAttribute('data-seconds') || '0', 10);

            const date = new Date(year, month, days, hours, minutes, seconds);

            this.countDownTimer(date, <HTMLElement>elem);
        }
    }

    /** 
     * Countdown Timer
     */
    private countDownTimer(endDate: Date, elem: HTMLElement) {
        if (!elem) {
            return;
        }

        var timer: any;

        this.countdown(endDate, timer, elem);
        timer = setInterval(() => {
            this.countdown(endDate, timer, elem);
        }, 1000);
    }

    /**
     * Führt den Countdown aus
     * @param endDate 
     * @param timer 
     * @param elem 
     * @returns 
     */
    private countdown(endDate: Date, timer: any, elem: HTMLElement): void {

        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;

        var now = new Date();
        var distance = endDate.getTime() - now.getTime();
        if (distance < 0) {

            clearInterval(timer);
            elem.innerHTML = '';

            return;
        }

        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        const cdDays = elem.querySelector('.cdDays');
        if (cdDays) {
            cdDays.innerHTML = days.toString();
        }
        const cdHours = elem.querySelector('.cdHours');
        if (cdHours) {
            cdHours.innerHTML = hours.toString();
        }
        const cdMinutes = elem.querySelector('.cdMinutes');
        if (cdMinutes) {
            cdMinutes.innerHTML = minutes.toString();
        }
        const cdSeconds = elem.querySelector('.cdSeconds');
        if (cdSeconds) {
            cdSeconds.innerHTML = seconds.toString();
        }
    }

    /** Slider vorbereiten */
    private prepareSliders(restartInterval = false): void {
        const sliders = document.querySelectorAll('.slider-outer');
        if (!sliders || sliders.length === 0) {
            return;
        }
        const width = document.body.clientWidth || window.innerWidth || document.documentElement.clientWidth;

        const xsMax = 767;
        const smMax = 991;
        const mdMax = 1199;
        for (let i = 0; i < sliders.length; i++) {
            const currentSlider = sliders[i];

            if (!currentSlider) {
                continue;
            }

            // Ändert die Anzahl der Elemente pro Slide entsprechend der Fensterbreite
            // let itemsPerSlide: number;
            const originalItemsPerSlide = parseInt((currentSlider.getAttribute('data-itemso') || '1'), 10);
            let itemsPerSlide = 1;
            if (originalItemsPerSlide > 1) {
                if (width <= xsMax) {
                    itemsPerSlide = 1;
                }
                // else if (width <= smMax) {
                //     itemsPerSlide = 2;
                // } else if (width <= mdMax) {
                //     if (originalItemsPerSlide > 3) {
                //         itemsPerSlide = 3;
                //     } 
                // } 
                else {
                    itemsPerSlide = originalItemsPerSlide;
                }
            }
            if (!itemsPerSlide) {
                itemsPerSlide = originalItemsPerSlide;
            }
            // if (itemsPerSlide) {
            currentSlider.setAttribute('data-items', itemsPerSlide.toString());
            // }

            // Indikatoren ggf. anpassen
            const sliderItems = currentSlider.querySelectorAll('.slider-inner > .item');
            const countItems = sliderItems.length;
            const countNeededIndicators = itemsPerSlide > 1 ? Math.ceil(countItems / itemsPerSlide) : countItems;
            const countIndicators = document.querySelectorAll('.indicator-area[data-slider-id="' + currentSlider.id + '"] > .indicator').length;
            if (countNeededIndicators != countIndicators) {
                const indicatorArea = document.querySelector('.indicator-area[data-slider-id="' + currentSlider.id + '"]');
                if (indicatorArea) {
                    indicatorArea.innerHTML = '';
                    for (let j = 0; j < countNeededIndicators; j++) {
                        const elem = document.createElement('div');
                        elem.classList.add('indicator');
                        if (j === 0) {
                            elem.classList.add('active');
                        }
                        elem.setAttribute('data-slide-to', j.toString());
                        elem.setAttribute('data-slider-id', currentSlider.id);

                        indicatorArea.appendChild(elem);
                    }
                }
            }

            // Bei Resize wird der Slider neu gestartet
            if (restartInterval) {
                // Interval stoppen
                const dtIntrvlNm = currentSlider.getAttribute('data-interval-name');
                if (dtIntrvlNm) {
                    clearInterval(parseInt(dtIntrvlNm, 10));
                }

                // Alle Werte zurücksetzen
                currentSlider.setAttribute('data-active-index', '0');
                (<HTMLElement>currentSlider.querySelector('.slider-inner')).style.transform = 'translate3d(0, 0, 0)';

                // Die ersten Slider-Elemente auf aktiv setzen
                for (let k = 0; k < sliderItems.length; k++) {
                    const child = sliderItems[k];

                    if (k < itemsPerSlide && child.classList.contains('active') === false) {
                        child.classList.add('active');
                    } else {
                        child.classList.remove('active');
                    }
                }
            }

            // Steuerung per Interval
            this.startSliderInterval(currentSlider);
        }

        // Steuerung per Indicator
        const sliderIndicators = document.querySelectorAll('.indicator-area');
        for (let i = 0; i < sliderIndicators.length; i++) {
            const indicatorArea = sliderIndicators[i];
            const childrenIndicators = indicatorArea.querySelectorAll('.indicator');

            for (let j = 0; j < childrenIndicators.length; j++) {
                const singleIndicator = childrenIndicators[j];

                singleIndicator.addEventListener('click', (ev) => this.slideByIndicators(ev, <HTMLElement>indicatorArea, <HTMLElement>singleIndicator));
            }

        }
    }

    /** Startet den Slider Interval */
    private startSliderInterval(sliderInterval): void {
        const interval = parseInt(sliderInterval.getAttribute('data-interval'), 10);
        if (isNaN(interval)) {
            return;
        }

        const intervalId = setInterval(() => {
            this.slideByInterval(sliderInterval);

        }, interval);

        sliderInterval.setAttribute('data-interval-name', intervalId);
    }

    /**
     * Auto on Interval
     * @param sliderElement 
     * @returns 
     */
    private slideByInterval(sliderElement: HTMLElement): void {
        const sliderItems = sliderElement.querySelectorAll('.slider-inner > .item');
        const itemsPerSlide = parseInt(sliderElement?.getAttribute('data-items') || '1', 10);

        if (!sliderItems || !itemsPerSlide || sliderItems.length <= itemsPerSlide) {
            return;
        }

        let lastActiveIndex = parseInt(sliderElement.getAttribute('data-active-index') || '0', 10);
        const countElements = sliderElement.querySelectorAll('.slider-inner > .item').length;
        let activeIndex = 1;

        // Holt den Abstand zwischen den einzelnen Items zur Berechnung
        let space = 0;
        const singleItem = <HTMLElement>sliderItems[0];
        const singleMarginRight = window.getComputedStyle(singleItem).marginRight;
        if (singleMarginRight) {
            space = parseInt(singleMarginRight, 10);
        }

        if (!isNaN(lastActiveIndex)) {
            if (lastActiveIndex === countElements - itemsPerSlide) {
                activeIndex = 0
            }
            else {
                activeIndex = lastActiveIndex + 1;
            }

            if (activeIndex > sliderItems.length - itemsPerSlide) {
                activeIndex = 0;
            }
        } else {
            lastActiveIndex = 0;
        }
        sliderElement.setAttribute('data-active-index', activeIndex.toString());

        let width = 0;
        for (let i = 0; i < sliderItems.length; i++) {
            var newWidth = sliderItems[i].clientWidth + (itemsPerSlide > 1 ? space : 0);
            if (i > 0 && i <= activeIndex) {
                width += newWidth;
            }
            if (i === lastActiveIndex) {
                sliderItems[i].classList.remove('active');
            }
            if (i >= activeIndex && i < sliderItems.length && i < (activeIndex + itemsPerSlide)) {
                sliderItems[i].classList.add('active');
            }
        }

        const sliderInner = sliderElement.querySelector('.slider-inner');
        (<HTMLElement>sliderInner).style.transform = 'translate3d(-' + width + 'px, 0, 0)';

        // Indicatoren setzen
        const indicators = document.querySelectorAll('.indicator-area .indicator[data-slider-id="' + sliderElement.id + '"]');
        const currentActiveIndicator = activeIndex > 0 ? Math.floor((activeIndex + (itemsPerSlide - 1)) / itemsPerSlide) : 0;
        for (let i = 0; i < indicators.length; i++) {
            const singleIndicator = indicators[i];
            if (i === currentActiveIndicator) {
                singleIndicator.classList.add('active');
            } else {
                singleIndicator.classList.remove('active');
            }

        }
    }

    /**
     * Click on Indicator
     * @param ev 
     * @param indicatorArea 
     * @param singleIndicator 
     */
    private slideByIndicators(ev, indicatorArea: HTMLElement, singleIndicator: HTMLElement): void {
        const nextIndex = parseInt(singleIndicator?.getAttribute('data-slide-to') || '0', 10);
        const dtsldId = singleIndicator.getAttribute('data-slider-id');
        if (!dtsldId) {
            return;
        }
        const slider = document.getElementById(dtsldId);
        if (!slider) {
            return;
        }
        const itemsPerSlide = parseInt(slider.getAttribute('data-items') || '1', 10);

        // Interval stoppen, falls vorhanden
        const dataIntervalName = 'data-interval-name';
        let restartInterval = false;
        if (slider.getAttribute(dataIntervalName)) {
            const dtaIntrvlNme = slider.getAttribute(dataIntervalName);
            if (dtaIntrvlNme) {
                clearInterval(parseInt(dtaIntrvlNme, 10));
                slider.removeAttribute(dataIntervalName);
            }

            restartInterval = true;
        }

        const list = indicatorArea.children;
        for (var i = 0; i < list.length; i++) {
            list[i].classList.remove('active');
        }
        singleIndicator.classList.add('active');

        const slides = slider.querySelectorAll('.slider-inner > .item');
        // var lastActive;
        let nextActive: HTMLElement;
        for (var i = 0; i < slides.length; i++) {
            if (slides[i].classList.contains('active')) {
                // lastActive = slides[i];
                slides[i].classList.remove('active');
            }
            if (i === nextIndex) {
                nextActive = <HTMLElement>slides[i];
            }
        }

        const sliderInner = slider.querySelector('.slider-inner');
        if (!sliderInner) {
            return;
        }

        let widthVal: number;
        // Anzahl der übrigen Elemente
        var rest = slides.length - (itemsPerSlide * nextIndex);
        let start: number;
        let end: number;

        // Holt den Abstand zwischen den einzelnen Items zur Berechnung
        let space = 0;
        const singleItem = <HTMLElement>sliderInner.children[0];
        const singleMarginRight = window.getComputedStyle(singleItem).marginRight;
        if (singleMarginRight) {
            space = parseInt(singleMarginRight, 10);
        }

        if ((nextIndex + 1) === (Math.ceil(slides.length / itemsPerSlide)) && rest !== itemsPerSlide) {
            const widthLeftover = ((sliderInner.clientWidth - (space * (itemsPerSlide - 1))) / itemsPerSlide + space) * rest;
            const lastIndex = nextIndex - 1;

            // Bisheriger Wert
            widthVal = sliderInner.clientWidth * lastIndex + (itemsPerSlide > 1 ? (space * lastIndex) : 0);
            // + Restwert der einzelnen Elemente
            widthVal += widthLeftover;

            start = slides.length - 1 - rest;
            end = slides.length - 1;
        } else {
            widthVal = nextIndex === 0 ? 0 : sliderInner.clientWidth * nextIndex + (itemsPerSlide > 1 ? (space * nextIndex) : 0);

            start = nextIndex * itemsPerSlide;
            end = start + (itemsPerSlide - 1)
        }

        // Neue aktive setzen
        let startActive = start;
        while (startActive <= end) {
            slides[startActive].classList.add('active');
            startActive++;
        }

        (<HTMLElement>sliderInner).style.transform = 'translate3d(-' + widthVal + 'px, 0, 0)';

        if (restartInterval) {
            const dtntrvl = slider.getAttribute('data-inverval');
            if (dtntrvl) {
                const interval = parseInt(dtntrvl, 10);
                slider.setAttribute('data-active-index', start.toString())

                // Interval neu starten
                setTimeout(() => {
                    my.startSliderInterval(slider);
                }, interval);
            }
        }
    }

    /**
     * Entfernt Validierungsinformationen, wenn das zugehörigen Feld geändert wird
     */
    private handleFormErrors(): void {
        const elements = document.querySelectorAll('.field-validation-error');
        if (!elements) {
            return;
        }

        for (let i = 0; i < elements.length; i++) {
            const err = elements[i];

            const elemFor = err.getAttribute('data-valmsg-for');
            if (!elemFor) {
                continue;
            }

            const formElems = document.getElementsByName(elemFor);
            if (!formElems) {
                continue;
            }

            for (let j = 0; j < formElems.length; j++) {
                const formElem = formElems[j];
                formElem.addEventListener('change', () => {
                    err.classList.remove('field-validation-error');
                    err.classList.add('field-validation-valid');
                    err.innerHTML = '';
                });
            }
        }
    }

    /**
     * Prüft alle Elemente darauf, ob sie im sichtbaren Bereich sind und animiert die Anzeige entsprechend
     * -> Animation nur bei erster Anzeige, anschließend bleibt der Inhalt so stehen
     * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
     */
    private handleIntersectionObserver(): void {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Element in sichtbarem Bereich
                    // entry.target.classList.add('mask-shown');
                    entry.target.classList.add('mask-shown');
                }
            });
        },
            // {
            //     root: null,
            //     rootMargin: '0px',
            //     threshold: 0.1
            // }
        )

        const hiddenElements = document.querySelectorAll('.mask-hidden');
        hiddenElements.forEach((el) => observer.observe(el));
    }

    /**
     * Setzt die EventListener für die mobile Navigation
     */
    private handleNavigation(): void {
        const nav = document.getElementById('navbar');
        if (!nav) {
            return;
        }

        const elementsTrigger = nav.querySelectorAll('[data-navtrigger]');
        if (!elementsTrigger) {
            return;
        }

        for (let i = 0; i < elementsTrigger.length; i++) {
            const element = elementsTrigger[i];
            element.addEventListener('click', () => {
                const dataVal = element.getAttribute('data-navtrigger');

                // holt das data-url Attribut für die Prüfung auf Inhalt
                const dataUrl = document.querySelector('[data-navident="' + dataVal + '"]')?.getAttribute('data-url');

                // Navigationspunkt ist direkt verlinkt (kein Sub-Menu)
                if (dataUrl?.length) {
                    return;
                }

                const pairs = nav.querySelectorAll('[data-navtrigger="' + dataVal + '"], [data-navident="' + dataVal + '"]');

                if (!pairs) {
                    return;
                }

                for (let j = 0; j < pairs.length; j++) {
                    const pairElem = pairs[j];
                    pairElem.classList.toggle('open');
                }

                nav.classList.toggle('open');
            });

        }
    }

    /**
     * Comparison Slider
     * -> Vergleicht zwei Bilder mit-/übereinander
     */
    private handleComparisonSlider(): void {
        const elements = document.querySelectorAll('.comparison-slider');
        if (!elements) {
            return;
        }

        for (let i = 0; i < elements.length; i++) {
            const slider = elements[i];

            const rangeSlider = slider.querySelector('input[type=range]');
            if (!rangeSlider) {
                continue;
            }

            rangeSlider.addEventListener('input', (ev) => {
                // Aktuellen Range-Wert holen
                const rangeValue = parseInt((<HTMLInputElement>ev.target)?.value);

                // CSS Variable mit Range-Wert setzen
                (<HTMLElement>slider).style.setProperty('--comparison-value', `${rangeValue}%`);

                // SVG curve holen
                const svgPath = slider.querySelector('clipPath[id="curve"] path');
                if (!svgPath) {
                    return;
                }

                const sliderCurve = (rangeValue < 67 ? 67 : rangeValue) / 100;

                svgPath.setAttribute('d', 'M0 1L3.26245e-08 0L1 3.76263e-08C1 0.500013 ' + sliderCurve + ' 1 ' + sliderCurve + ' 1L0 1Z')

                const button = slider.querySelector('button');
                if (!button) {
                    return;
                }

                // Werte sind errechnet und somit fix! (von lumion.com übernommen/ausgerechnet)

                // Ranger über 70%
                if (rangeValue > 70) {
                    // 71% => 65.458
                    // 70% => 64.26
                    const fact71to100 = (65.458 / 64.26) - 1;
                    const steps = rangeValue - 70;
                    const result = 64.26 * (1 + (steps * fact71to100));

                    button.style.left = result + '%';

                } else {
                    // Range 0 - 70%
                    const fact0to70 = 0.918;
                    button.style.left = rangeValue * fact0to70 + '%';
                }

            });
        }
    }



    /**
     * Fängt die Klicks des Custom-Number-Steppers ab und zählt entsprechend im Input hoch/runter
     */
    private handleCustomNumberStepper() {
        var buttons = document.querySelectorAll('form .custom-number-stepper');
        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
            button.addEventListener('click', function (e) {
                e.preventDefault();

                const elem = buttons[i].classList;
                if (elem == null) {
                    return;
                }

                const input = (<HTMLElement>e.target).parentElement?.querySelector('.number-stepper') as HTMLInputElement;

                if (input == null) {
                    return;
                }

                let add = 0;

                if (elem.contains('up')) {
                    // Hochzählen
                    // Input Element suchen
                    const prevElem = (<HTMLElement>e.target).previousElementSibling;
                    if (prevElem == null) {
                        return;
                    }
                    add = 1;

                } else if (elem.contains('down')) {
                    // Runterzählen
                    // Input Element suchen
                    const nextElem = (<HTMLElement>e.target).nextElementSibling;
                    if (nextElem == null) {
                        return;
                    }
                    add = -1;
                } else {
                    return;
                }

                // Keine Funktionalität, wenn input disabled ist
                if (input.disabled) {
                    return;
                }

                let inputmin = Number(input.min)
                const val = Number(input.value);
                let result = (isNaN(val) ? inputmin : val) + add;
                if (result < inputmin) {
                    result = inputmin;
                }
                input.value = result.toString();

                input.dispatchEvent(new Event('input'));

                if (input.previousElementSibling) {
                    if (result == inputmin) {
                        input.previousElementSibling.classList.add('disabled');
                    } else {
                        input.previousElementSibling.classList.remove('disabled');
                    }
                }

                // Seite neu laden
                if (!button.parentElement) {
                    return;
                }
                const reloadButtonId = button.parentElement.getAttribute('data-reload');
                if (!reloadButtonId) {
                    return;
                }
                const reloadButton = document.getElementById(reloadButtonId);
                if (!reloadButton) {
                    return;
                }
                (<HTMLButtonElement>reloadButton).click();
            });
        }
    }

    /**
     * Prüft bestimmte Container auf die höchste Höhe und setzt diesen Wert bei allen betroffenen Containern
     */
    private matchContainerHeight(): void {
        const elements = document.querySelectorAll('[data-match-height]');
        if (!elements) {
            return;
        }
    
        const groups: Record<string, HTMLElement[]> = {};
    
        elements.forEach(el => {
            const key = el.getAttribute('data-match-height');
            if (key) {
                if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(el as HTMLElement);
            }
        });

        for (const key in groups) {
            if (groups.hasOwnProperty(key)) {
                const group = groups[key];
                this.calculateHeight(group, false);
            }
        }
    }

    /**
     * Gibt allen Elementen einer Gruppe dieselbe Mindesthöhe
     * Die Elemente dürfen danach noch wachsen
     * Die Trennlinien fluchten, beim Aufklappen wächst nur die betroffene Kachel
     */
    private matchContainerMinHeight(): void {
        const elements = Array.from(document.querySelectorAll<HTMLElement>('[data-match-min-height]'));
        if (!elements.length) {
            return;
        }

        // Alte Mindesthöhe vor dem Messen entfernen
        elements.forEach(el => el.style.minHeight = '');

        window.setTimeout(() => {
            const groups: Record<string, HTMLElement[]> = {};

            elements.forEach(el => {
                const key = el.getAttribute('data-match-min-height');
                if (!key) {
                    return;
                }

                if (!groups[key]) {
                    groups[key] = [];
                }

                groups[key].push(el);
            });

            for (const key in groups) {
                if (!groups.hasOwnProperty(key)) {
                    continue;
                }

                const group = groups[key];
                let height = 0;

                group.forEach(el => {
                    // Aufgeklappte Laufzeiten nicht mitmessen
                    if (el.querySelector('input[type="radio"]:checked')) {
                        return;
                    }

                    if (el.offsetHeight > height) {
                        height = el.offsetHeight;
                    }
                });

                if (height > 0) {
                    group.forEach(el => el.style.minHeight = height + 'px');
                }
            }
        }, 100);
    }

    /**
     * Initialisiert das Popup (Trigger-Button + Auto-Show + Schließen)
     */
    private initPopUp(): void {
        // Popup Element holen
        const popup = document.querySelector<HTMLElement>("#popup");

        // Wenn true, wird das Popup pro Browser-Session nur einmal automatisch gezeigt
        const autoOncePerSession = true;

        // Kein Popup im DOM dann beenden
        if (!popup) {
            return;
        }

        // Klickfläche zum Schließen außerhalb der Popup Box 
        const overlay = popup.querySelector<HTMLElement>(".overlay");

        // Schließen-Button im Popup
        const closeBtn = popup.querySelector<HTMLElement>(".close-popup");

        if (!overlay || !closeBtn) {
            return;
        }

        // Button um das Popup manuell zu öffnen 
        const trigger = document.querySelector<HTMLElement>(".popup-btn");

        // Timehandle für Auto Close
        let autoTimer: number | undefined;

        // Key pro Popup (pro Session)
        const key = `popupShown:${popup.id || "default"}`;
        const hasShownThisSession = !!sessionStorage.getItem(key);
        const isFirstVisitThisSession = !hasShownThisSession;

        // Blendet den Popup-öffnen-Button ein 
        const showBtn = () => {
            trigger?.classList.add("is-in");
            trigger?.classList.remove("is-out");
        };

        // Blendet den Öffnenbutton aus 
        const hideBtn = () => {
            trigger?.classList.add("is-out");
            trigger?.classList.remove("is-in");
        };

        // Öffnet das Popup und versteckt den Öffnen-Button
        const open = () => {
            popup.classList.add("active");
            hideBtn();
        };

        // Schließt das Popup, zeigt den Button wieder und räumt Timer auf 
        const close = () => {
            popup.classList.remove("active");
            showBtn();
            if (autoTimer) {
                clearTimeout(autoTimer);
                autoTimer = undefined;
            }
        };

        // Close Interaktionen: Overlay Klick oder Close Button
        overlay.addEventListener("click", close);
        closeBtn.addEventListener("click", close);

        if (trigger) {
            trigger.addEventListener("click", open);
        }

        // Button zum manuellen Öffnen nur einblenden, wenn es nicht der erste Besuch in dieser Session ist
        const scheduleShowBtn = () => setTimeout(showBtn, 2500);
        if (!isFirstVisitThisSession) {
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", scheduleShowBtn, { once: true });
            } else {
                scheduleShowBtn();
            }
        }

        // Auto-Show-Logik
        // Beim allerersten Aufruf in der Session: sofort (nach Load + 2,5s) öffnen
        const runAutoShow = () => {
            if (autoOncePerSession && hasShownThisSession) {
                return; 
            }

            // ab hier: erster Besuch dieser Session
            if (autoOncePerSession) {
                sessionStorage.setItem(key, "1");
            }

            // Öffnen und Auto-Close Timer starten 
            open();
            autoTimer = window.setTimeout(close, 5000);
        };

        // Wenn alles komplett geladen ist, Auto-Show nach 2,5s triggern
        // ansonsten auf Seitenladeende warten und dann 2,5s später öffnen 
        const scheduleAutoShow = () => setTimeout(runAutoShow, 2500);

        if (document.readyState === "complete") {
            if (isFirstVisitThisSession) {
                scheduleAutoShow();
            }
        } else {
            if (isFirstVisitThisSession) {
                window.addEventListener("load", scheduleAutoShow, { once: true });
            }
        }
    }

    /**
     * Zeigt oder versteckt den Grund Block ("Grund für keine Verlängerung"),
     * abhängig davon ob "Keine Verlängerung gewünscht" oder "Verlängerung gekündigt" ausgewählt wurde
    */
    private handleReasonNoSubExtensionBlock(): void {
        // Das Haupt-Dropdown "Status Erinnerungs E-Mail" auswählen
        var statusDropdown = document.querySelector<HTMLSelectElement>('[name="BillingData.SentReminderSubExtension"]');

        // Den Block mit den Grund-Feldern auswählen
        var reasonBlock = document.getElementById('reasonNoSubExtensionBlock');

        // Abbrechen, falls eines der Elemente nicht auf der Seite existiert
        if (!statusDropdown || !reasonBlock){
            return;
        }

        // Lokale Referenzen damit TypeScript innerhalb der Change-Funktion keinen Null-Fehler wirft
        var dropdown = statusDropdown;
        var block = reasonBlock;

        // Wenn sich das Dropdown ändert, prüfen ob der Grund-Block angezeigt werden soll
        dropdown.addEventListener('change', function () {
            // Prüfen ob "Keine Verlängerung gewünscht" oder "Verlängerung gekündigt" ausgewählt ist
            var isNoRenewal = dropdown.value === 'NoSubExtensionWished' || dropdown.value === 'SubExtensionCancelled';

            // Block ein- oder ausblenden
            if (isNoRenewal) {
                block.style.display = 'block';
            } else {
                block.style.display = 'none';
            }
        });
    }

}

var my: My;

const initializeMy = (): void => {
    my = new My();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMy, { once: true });
} else {
    initializeMy();
}